module.exports  = [
  {
    id: 0,
    title: '亚商活动丨与掌门人同行：致敬共和国70周年主题活动',
    Publisher: '亚商ABC',
    time: '2019.09.21',
    content: [
      {
        text: '2019年9月21日，由亚商集团，复旦大学管理学院联合主办，上海股权投资协会协办，申万宏源证券、天风证券研究支持，第一财经全程直播的“与掌门人同行——致敬共和国70周年”主题活动在上海复旦大学管理学院顺利举办，原中国经济体制改革委员会副主任高尚全老先生，亚商集团创始人、董事长陈琦伟先生，复旦大学管理学院陆雄文院长，御风集团董事长、万通集团创始人冯仑先生，嘉御基金创始合伙人兼董事长卫哲先生，第一财经总编辑杨宇东先生到会，并在上午的开场主题演讲和对话环节做了精彩分享。',
        imgurl: '19-0921_1.jpg',
        imgDetail: ''
      },
      {
        text: '在行业巅峰对话环节，由复旦大学管理学院王安宇副教授主持“强国根基、先进制造与信息技术共成长”主题讨论，火山石资本管理合伙人章苏阳先生，道同投资创始合伙人、永续自然资源保护基金会理事长张醒生先生，通恒国际投资有限公司、云南红酒庄集团董事长武克钢先生，浙江大东吴集团有限公司董事长吴淑英女士参与该环节讨论。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '下午的精彩活动，有请到了中国民生银行董事长洪崎先生，平安集团总经理任汇川先生，德龙集团副总裁田立新先生就“中国背景下的创新趋势与机遇”分别作了主题分享；而“中国产业升级下的医疗健康市场与新时代消费”的行业对话，在创业慧康董事长葛航先生，111集团联合创始人兼执行董事长于刚先生，珀莱雅董事长侯军呈先生，探路者控股集团董事长兼CEO王静女士，管会教育董事长王红新先生，凯石资本管理合伙人俞铁成先生以及主持人亚商资本合伙人于伟霞女士之间热烈展开。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '会上，九十高龄的原中国经济体制改革委员会副主任高尚全老先生发表主题演讲，伴随共和国70年的历程，体制改革带来美好生活的方方面面，激荡过往，坚定未来。现场亚商集团和复旦大学管理学院也为高老准备了生日惊喜，全场与会嘉宾一同与高老度过九十大寿。',
        imgurl: '19-0921_2.jpg',
        imgDetail: ''
      },
      {
        text: '民营企业家是国家的宝藏。关注“新生代企业家的持续成长”是亚商集团和复旦大学管理学院共同关心的话题。在对话环节，三位对话人分别从各自角度阐述几代企业家：亚商集团创始人、董事长陈琦伟先生提出今天共和国半壁江山是民营企业家撑起来的，第一代企业家有饥饿时代记忆，有艰苦奋斗时代记忆，民营企业家群体已经是共和国70年改革开放40年的最重要财产与财富。民营企业家要不断学习，注重传承。复旦大学管理学院陆雄文院长表示，第一代企业家能最终成长为行业领袖，都有一个共同特点，那就是爱好学习，一直学习新的知识和思想，愿意突破自己，突破局限性。新一代企业家应有更宽广视野和社会责任考量，想到为企业创造利润的时候，也要为社会带来新福利。这样企业家才是具有时代特征。同场，嘉御基金董事长卫哲先生提出，第一代企业家不会退也不能退，一路前进；而第二代企业家知进退知平衡懂妥协，知道有时退就是进，第一代第二代企业家之间，最重要的是互相学习和传承。',
        imgurl: '19-0921_3.jpg',
        imgDetail: ''
      },
      {
        text: '在上午会上，由亚商集团创办的掌门人正经塾，与复旦大学管理学院的合作工作站签约仪式也是当天活动的一个小高潮。新生代企业家的健康成长与持续发展是中国欣欣向荣的一块基石，是老一辈企业家心心念念的责任。少年强则中国强。',
        imgurl: '19-0921_4.jpg',
        imgDetail: ''
      }
    ]
  },
  {
    id: 1,
    title: '亚商活动丨亚商投顾30专家工作会议圆满召开',
    Publisher: '亚商ABC',
    time: '2019.12.19',
    content: [
      {
        text: '在亚商投顾总经理黄文佳的主持下，亚商投顾“年度最具健康成长力上市公司30强”评选活动第三次专家会议在亚商集团总部圆满召开，亚商投顾董事长陈琦伟先生、上海证券交易所原首席经济学家胡汝银先生、中泰证券首席经济学家李迅雷先生、申万宏源（国际）集团原副董事长陆文清先生、国家会计学院原院长夏大慰先生、火山石创投基金创始合伙人章苏阳先生、中金资本运营有限公司副总裁单俊葆先生、嘉御基金创始合伙人卫哲先生、深圳价值在线信息科技股份有限公司联合创始人段亚林先生、东方证券独立董事许志明先生、融科投资管理公司董事长毛勇春先生、溢璞资产总经理寻明辉先生、原华宝基金股票基金经理牟旭东先生、凯石资本合伙人俞铁成先生、原亚商副总文兴先生等30专家出席会议。\n',
        imgurl: 'news6_1.jpg',
        imgDetail: ''
      },
      {
        text: '<div style="font-weight: bold; color: #2E353D;">Part1——追寻价值，健康成长</div>',
      },
      {
        text: '会议开始，亚商投顾总经理黄文佳对“中国最具健康成长力上市公司”评估再度做了详细阐述。在隐雷频曝的当下，过往A股投资人过度关注潜在成长空间而忽略企业健康成长度，甚至是忽视价值投资的问题暴露出来，亚商投顾开启的“中国最具健康成长力30强上市公司”评选以专家评选结合大数据、AI新技术等多层次手段工具，找到率先通过行业整合、转型发展、深化开放等时代机遇，继续保持健康成长的优质企业以及其代表的新兴发展战略，助力市场投资人拒绝“爆雷”。',
        imgurl: 'news6_2.jpg',
        imgDetail: ''
      },
      {
        text: '<div style="font-weight: bold; color: #2E353D;">Part2——宾朋满座，闳言高论</div>',
      },
      {
        text: '会上，多位专家结合2019年亚商投顾走访30强的情况反馈，就亚商投顾30强评选进一步如何展开及改进方向进行了激烈的讨论，将会议氛围推向一轮高潮。',
        imgurl: 'news6_3.jpg',
        imgDetail: ''
      },
      {
        text: '在会议的最后，亚商投顾董事长陈琦伟做了总结发言，并宣布亚商投顾将于1月16日在上海交通大学高级金融学院举办“2020中国资本市场健康成长高峰论坛”，会上将举行30强评估体系发布仪式，届时中国经济体制改革的制定与参与者、行业龙头公司掌门人、全球顶级投资机构合伙人、国内头部券商首席，高朋满座，闳言高论，相信在各位业界大拿的支持与参与下，亚商投顾健康成长力评估体系定能成为中国资本市场走向成熟的重要推力。',
      }
    ]
  },
  {
    id: 2,
    title: '初心和使命间，最重要的是逻辑',
    Publisher: '亚商ABC',
    time: '2019.08.21',
    content: [
      {
        text: '<div style="color: blue;">初心和使命间，最重要的是逻辑</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '亚商集团董事长陈琦伟先生',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '谈大竞争时代下的企业战略之道',
        imgurl: 'ybl2.jpg',
        imgDetail: ''
      },
      {
        text: '近两年，世界贸易紧张局势不期而至，经济下行压力空前加大，中国在经历一场严峻的挑战。在大变局的时代，企业需要依托不断改善的企业外部环境，扎扎实实做好自身的经营和管理，从企业战略和竞争两个维度来认知环境，真正理解机会在哪里？真正的挑战和价值是什么？',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="font-weight: bold;">亚商集团董事长陈琦伟先生在亚布力企业家论坛的夏季峰会上，对企业战略之道，结合他沙场久战的经验，现场分享：</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '今天这个大主题是讲战略，但是我要提到一个关键词——“逻辑”。中国过去20年真是黄金时期，20来年我也参加过很多重要会议。但是现在大家首先意识到，我们进入一个完全不同的时代了。做事的方法跟以前会有些什么不一样？自己应该怎么做？这需要思考，而且这还只是刚刚开始。亚商这20年来投资了120来家企业，企业家接触也很多，都在或多或少陷入一种困难的境地，这是事实。这里讲的状态的变化，就是我们不大可能再像过去20年一样一以贯之地意气风发，老是看前面有什么更大的机会、更多的发展。这个阶段更多的可能需要停下来反思一下我们现在困难的原因、我们不怕进坑，我们一定会越过一个一个的坎儿。但这也说明一个事实，我们现在是在坑里，是碰到坎儿了。进了坑，碰到坎儿了的时候就要反思一下，为什么会进这个坎儿？怎么出来？这跟以往有点不一样，这里就有个逻辑的问题。战略这个词也是讲了几十年，企业战略这个概念、商学院、MBA教育引进得也很快，引进了以后每年到处会议都会讲战略。战略讲得这么多，但是我们中国企业做事情的缺陷在哪里？为什么现在大面积的企业倒闭、爆仓，企业生命周期大大缩短。我认为这里的核心原因不是战略讲得不够，而是逻辑讲得不够。我们中国文化其实就是轻视逻辑的，我们喜欢讲目标、讲宏大故事，好像只要我的初心是好的、我的使命是好的，中间就都能对了。但不是那么回事。在初心和使命中间是有逻辑的，那就是怎样能做得到？最近两年时间，因为从股市爆仓，IPO进程直接影响到企业上市的速度，很多企业家很苦闷，他不知道为什么陷入困境。然后聊了以后，归纳出来，大家越来越意识到我们对逻辑太忽略了，这个是绝对值得在一个新的时代重视的一个重要的方面。',
        imgurl: 'ybl3.jpg',
        imgDetail: ''
      },
      {
        text: '亚商今年上半年的时候推出了一个非常有意义的活动，关注企业健康成长的逻辑。我们做了一个中国最具健康成长力30强上市公司的评选。这个评选我们完全用新方法了，因为亚商是中国最早做中国上市公司50强评选，那是90年代，那时我们是开拓者，跟中国证券报合作了8年。后来做评选就很多了，鱼龙混杂，我们就不做了。现在发现这个逻辑问题是大家忽略的，我们做了以后有新的成就感和非常深刻的体会。我们先用大数据，在全国将近4000家A股上市公司里面做筛选，筛选出来200家，我们就用我们自己开发的人工智能的AI的评估系统，评估以后剩下59家，6月5日的时候我们组织了一个30人的专家委员会，都是有公信力的，国内资本市场、企业界做研究的、专业界最有公信力的人士筛选到现在剩下39家。39家已经很令人振奋了，我们把39家企业做成一个组合，因为他们都是A股上市公司，这个组合里面平均放置一个公司的股票，回撤回去，整个组合跑赢了大市30%以上，我现在不敢打保票说绝对没有暴雷的公司，但我们首先要搞清楚尽量不要暴雷。今年到现在为止已经跑赢大市近20%。现在大的机构投资者对这个组合非常感兴趣，炒股票的人对这个东西兴趣不大，他们希望能够抓住一匹黑马，能够翻一倍。我们这个全年回报率大概在15%左右，不会太大。我们探究了这些企业里面的共同点，这个共同点就佐证了我们自己的认知，在一个混沌的时代，讲究逻辑、讲究坚持，逻辑清楚了做事情就不会摇摇摆摆，不会说突然亢奋、突然沮丧，这39个掌门人，我们现在已经面对面谈了大概有十来个，他们都有一个共同的特点，也是经历过波折，但是现在他们对核心理念的坚持跟做法上的逻辑上的特色非常明显。今天我要讲的就是这个意思，现在是一个变革的时代，我们做企业战略，更加应注重企业战略的逻辑。谢谢！',
        imgurl: '',
        imgDetail: ''
      }
    ]
  },
  {
    id: 3,
    title: '亚商集团董事长陈琦伟先生携中国企业家团代表团见中国驻越南大使熊波',
    Publisher: '亚商ABC',
    time: '2019.06.21',
    content: [
      {
        text: '',
        imgurl: 'yn1.jpg',
        imgDetail: ''
      },
      {
        text: '',
        imgurl: 'yn2.jpg',
        imgDetail: ''
      }
    ]
  },
  {
    id: 4,
    title: '亚商观点 | 陈琦伟：健康是上市公司成长基石',
    Publisher: '亚商ABC',
    time: '2019.05.24',
    content: [
      {
        text: '<div style="color: blue;">生命体要想健康，首先头脑和灵魂要健康，对于公司来说，这个头脑和灵魂就是掌门人。当然不仅是实际控制人，也有可能是公司的领头人、以掌门人为主的核心班子。</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '“上市公司需要成长，更需要在健康基础上的可持续成长。”作为中国资本市场29年的见证者，亚商集团董事长陈琦伟与上证报记者一见面便提出上述观点。在他看来，这是当前亟需解决的核心问题，对中国资本市场的完善、长期投资理念的树立有着重要意义。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '上世纪五十年代出生的陈琦伟，称得上中国资本市场的“活化石”：1990年12月19日上交所开市第一锤敲响时，陈琦伟是现场见证者之一。他长期担任上交所公司治理专家咨询委员会委员，关注A股公司的一举一动。亚商集团的主要业务就是投资咨询。如今，面对A股“雷声阵阵”的现状，陈琦伟决定“再开先河”，为投资者审视上市公司提供一套新的标准。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '陈琦伟形象地将公司比作一个生命体，成长是需要的，但更重要的是健康，否则一味追求成长，短期虽有成效，长期很难走远。至于公司怎样健康成长，陈琦伟认为，首先是头脑，即掌门人的心智、能力，而这恰恰是传统财务方法所不涉及的。“希望以此寻找一批具有健康成长潜力的公司，为市场树立标杆，鼓励价值投资理念。”',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="color: blue;">要成长，更要健康</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '“与中国资本市场多年同行，我有个深刻的体会，上市公司的治理水平依然有待提高。2018年多因素叠加，上市公司爆雷现象异常增多，影响着A股公司的整体质量。”陈琦伟坦言。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '尤其是个别白马股的爆雷，对A股市场投资者信心造成不小的影响。“投资者被‘炸’怕了，为了不触雷，大家越来越浮躁，思维方式趋向散户化，最终导致期盼多年的长期投资理念依然无法建立，长期投资甚至被当成笑话。”',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '问题股爆雷，白马股也爆雷，这一现象令所有关心市场的人感到痛心。陈琦伟认为，过去资本市场将成长视为首要目标，甚至是唯一目标，成长“一俊遮百丑”，即使有质疑声音，也很快被短期亮丽的数据所掩盖，这种氛围反过来促使上市公司更迫切地追求短期成长，对风险熟视无睹。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '可成长终究不是一朝一夕就能完成的，公司要想真正实现长期成长，需要有个健康的体质，陈琦伟认为这正是成长的基础。“2018年A股市场频频爆雷，其根本是缺乏对健康的认知，片面追求成长，大量问题没有解决，集中到了这两年爆发。聚焦健康成长，就安稳得多。换句话说，健康是‘1’，成长及其他都是‘1’后面的‘0’。”',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="color: blue;">掌门人是公司健康之魂</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '如何判断一家公司是否存在爆雷风险？陈琦伟用一个形象的比喻给出了回答：将公司具象化成一个生命体，生命体健康，不生病，对应的就是公司不会爆雷。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '陈琦伟认为，资本市场长期以来已经对上市公司有了一套研究分析方法，涉及盈利能力、资产结构等多方面，但对A股来说，这种传统方法还不够。很多企业家知道怎么做一个好产品，但对于如何做好一家企业，他们的回答往往是只言片语，远不如对产品的分析那么有逻辑。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '基于这种情况，陈琦伟带领团队从生命体这个视角出发，找到了一条研究公司健康程度的新路径。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '“生命体要想健康，首先头脑和灵魂要健康，对于公司来说，这个头脑和灵魂就是掌门人。当然不仅是实际控制人，也有可能是公司的领头人、以掌门人为主的核心班子。”陈琦伟告诉记者，具体来看，评价由事业情怀和眼光、自信心、坚韧性、人格特质、执行力、自控力等六个要素为主组成，犹如生命体的灵魂和心智。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '过去30多年，陈琦伟和团队走访了几千家公司，丰富的阅历令他认识到，一个企业掌门人的价值观，决定企业至少一半的价值。“有些企业家能力很强，也能吃苦耐劳，可有些不良嗜好，这可能危害公司的健康发展。”',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '陈琦伟还提到了定力。他认为，现在市场纷繁复杂，很容易令企业家失去初心，这就需要考察企业家的初心、事业心、咬定主业的清晰度和执行力，看他能不能抵御诱惑，聚焦主业。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '掌门人这个如此重要的指标，在传统的考核体系中却是缺位的。陈琦伟表示，其实大部分上市公司的掌门人，在当今的互联网高度发达时代，其理念情怀行为都已有相当高的公众性，完全可以通过主题词筛选、抓取、专业分析、当面访谈交流等专业方法解决。为此，亚商已开发了一套人工智能基础上的分析系统，并结合在过去两年组建的几万名行业专家库系统，以及与亚商开展战略合作的数家研究机构等提供实质性支撑。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="color: blue;">健康与环境密不可分</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '陈琦伟认为，市场环境由两个板块组成，一是主业的市场周期和环境，二是金融环境。“此前A股出现的并购潮、定增潮、大股东质押潮，事后来看，与市场环境有关，也与上市公司自身有关。如果上市公司定力不足，容易走上过度扩张和加杠杆的不健康发展之路。如同生命体的饮食和消化系统，暴饮暴食或缺乏对饮食的科学认知，必然导致亚健康状态。”陈琦伟说。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '早在1993年，陈琦伟带领的亚商就组织了国内第一次收购兼并研讨大会。当时，他就认为，收购兼并不是个简单的事情，收购的失败率要高于成功率，因为收购不是简单的资产拿进来，而是后续的资产整合、协同。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '遗憾的是，20多年前就提出的观点，依然没有得到当下公司的重视。2013年开启的并购、定增和后续的质押浪潮，众多A股公司争相开展外延式并购，或是同业整合，或是延伸至上下游，有的甚至跨界收购，而它们在收购时，往往只考虑短期市值。整合要耗费资源，而很多企业对于希望达到什么效果、后续如何去做，几乎没有考虑。最终，昔日收购积累下巨额商誉，盈利能力却没有得到提高，只能眼睁睁看着风险爆发。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '在此基础上，陈琦伟认为要关注公司的“心血管系统”，即现金流指标基础上的健康财务结构。以往市场更多地关注营收、净利润这些指标，而这些指标是否健康，还需要关注现金流，特别是在经历了过度杠杆和去杠杆的大环境下，对其要给予更多的权重。在健康的头脑和灵魂、心血管系统基础上，再关注其他传统指标，对判断上市公司的健康程度更有效。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="color: blue;">为资本市场健康助力</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '看惯了市场的风云变幻、冷热更迭，陈琦伟依然保留着一份初心——希望通过引入“健康基础上的成长”这一理念，选出一批优质公司，为中国资本市场树立标杆，呼吁市场关注公司的健康成长，引导长期投资理念。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '据悉，亚商潜心钻研超过2年后，今年计划推出年度“中国上市公司健康成长评价体系”，依靠自主开发的智能评估系统，在大数据基础上筛选后由特邀专家群评选，获得评选结果，借此引导市场投资人关注年度最具健康成长潜力的代表性上市公司，逐渐形成中国资本场价值投资的一个有特色的参考体系。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '采访过程中，陈琦伟向记者详细介绍了筛选标准，其中既有AI大数据分析，也有几十名有经验和有相当公信力的资深专家的专业评价，更有实地调研后的理性判断，这是以往公司评价体系所不具备的。亚商将与公司掌门人进行深度沟通，对其进行面对面“体检”，最终选出30家上市公司。“这一评价体系将为资本市场吹来新风，入选的公司也将起到示范作用，为中国资本市场的健康发展助力。”',
        imgurl: '',
        imgDetail: ''
      }
    ]
  },
  {
    id: 5,
    title: '《掌门人说》发布会现场视频',
    Publisher: '亚商ABC',
    time: '2019.04.11',
    content: [
      {
        text: '2019年3月30日，献礼新中国七十年和改革开放四十年的重磅专题财经节目《掌门人说》在上海举行发布会。该节目聚焦发轫于中国经济的行业领袖级企业掌门人对本行业和经济大势的穿透性独到见解。从而在当前中国经济大势转型期的关键时点，帮助公众和资本市场精准了解相关产业和中国市场的未来价值亮点和机会。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="text-align: center;"><video controls="controls" width="900" height="510" poster="http://www.abc-group.cn/public-image/2019-03-30-001.png">' +
          '<source src="http://media.abc-group.cn/abc-group/%E6%96%B0%E9%97%BB%E7%B1%BB%E8%A7%86%E9%A2%91/%E3%80%8A%E6%8E%8C%E9%97%A8%E4%BA%BA%E8%AF%B4%E3%80%8B2019.3.30%20%E5%8F%91%E5%B8%83%E4%BC%9A%E7%B2%BE%E5%89%AAv0.1.mp4" type="video/mp4"></video></div>',
        imgurl: '',
        imgDetail: '发布会现场视频'
      }
    ]
  },
  {
    id: 6,
    title: '致敬中国产业领袖 亚商集团打造视频节目《掌门人说》',
    Publisher: '亚商ABC',
    time: '2019.04.08',
    content: [
      {
        text: '2019年3月30日，献礼新中国七十年和改革开放四十年的重磅专题财经节目《掌门人说》在上海举行发布会。该节目聚焦发轫于中国经济的行业领袖级企业掌门人对本行业和经济大势的穿透性独到见解。从而在当前中国经济大势转型期的关键时点，帮助公众和资本市场精准了解相关产业和中国市场的未来价值亮点和机会。',
        imgurl: 'zmrs1.png',
        imgDetail: ''
      },
      {
        text: '成立逾三十年的专业金融投资机构亚商集团作为中国改革开放40年历程与资本市场从无到有、发展至今的亲历和见证者，力邀企业界、资本界各路“掌门人”联袂呈现出这一顶级头部财经节目，体现其助力中国经济发展与改革，向市场传递更专业、更精准信息的情怀与使命。',
        imgurl: 'zmrs2.png',
        imgDetail: ''
      },
      {
        text: '《掌门人说》节目共分三个系列：“致敬中国产业领袖”，“致敬中国科创精英”，以及“致敬中国品牌英雄”。首系列嘉宾邀请到了TCL集团董事长、CEO李东生，杉杉集团董事局主席郑永刚，福耀集团董事局主席曹德旺，联想集团董事长杨元庆，分众传媒创始人江南春，美年大健康集团董事长俞榕，嘉御基金创始人及前阿里巴巴B2B总裁卫哲，1号店创始人、1药网联合创始人于刚等十多位中国顶级行业领袖，他们在节目中深度剖析产业价值，穿透性解读产业痛点、亮点和商机。掌门人话题辐射新零售、互联网科技、消费升级、新能源、医疗健康、金融科技等各个具重大影响力的行业。节目受众定位于基金经理、资本市场专业投资人士、中小企业家、创业者等精英人群，并将在腾讯、爱奇艺、第一财经、阳光卫视、CIBN、PPTV、今日头条、界面、全景网等权威主流媒体同步播出。',
        imgurl: 'zmrs3.png',
        imgDetail: ''
      },
      {
        text: '亚商集团创办人、董事长，本节目主创者陈琦伟博士在发布会上表示：“新中国七十年最重要的成果之一，是在改革开放过程中涌现的，成为众多中国主流产业领头人的中国企业家群体。亚商集团策划推出《掌门人说》高端财经系列节目，汇聚各主流产业的龙头企业的掌门人，首次集中展示这批领袖型企业家对相关产业的未来价值和商业机会的洞察。有助于国内外关注中国经济前景的专业人士和公众，具象性体会到中国未来的竞争力所在和商业机会。',
        imgurl: 'zmrs4.png',
        imgDetail: ''
      },
      {
        text: '据本节目联合出品方骑翼文化创始人于亭婷介绍：“掌门人说”将被打造成具备国际影响力的中国头部财经IP。除了财经节目，还将涵盖年度论坛盛典、线下专业财经沙龙、以及直达公众的互动和培训产品等版块，并开发针对专业财经人士与高净值人群关于投资、创业等线上结合线下的高附加值服务。',
        imgurl: 'zmrs5.png',
        imgDetail: ''
      },
      {
        text: '多位掌门人嘉宾对《掌门人说》节目给予了高度评价。TCL集团董事长李东生表示：“希望在节目中分享的这些经历，能够使更多的企业家和研究企业管理的人得到借鉴和帮助。”嘉御基金董事长卫哲表示：“《掌门人说》不是CEO说、总经理说，任何一个武术流派的掌门人必须承担使这个门派源远流长传承下去的使命。《掌门人说》这个节目，就是给大家一个机会能够把自己的企业、行业，以及对未来的理解沉淀下来，传承下去。”分众传媒创始人江南春认为：“《掌门人说》很大程度上体现出一个行业领导者对未来趋势的重要洞察。”',
        imgurl: 'zmrs6.png',
        imgDetail: ''
      }
    ]
  },
  {
    id: 7,
    title: '亚商年货丨亚超联赛主题年会来啦~！',
    Publisher: '亚商ABC',
    time: '2019.01.22',
    content: [
      {
        text: '2019年1月21日，亚商主题年会“亚超联赛”圆满举办。一整天丰富又有意义的年会安排，每位亚商人付出的努力和干劲，都为亚商2019年注入活力和动力。2019年的亚商，像一支训练有素的球队，配合无间、冲锋达阵、妙传助攻，射门得分！',
        imgurl: 'ycls1.jpg',
        imgDetail: '亚商超级杯足球赛——我们是一支真正的球队'
      },
      {
        text: '',
        imgurl: 'ycls2.jpg',
        imgDetail: '啦啦队助威——射门！'
      },
      {
        text: '',
        imgurl: 'ycls3.jpg',
        imgDetail: '场边激烈平板撑比拼'
      },
      {
        text: '',
        imgurl: 'ycls4.jpg',
        imgDetail: '淘汰赛——决出冠军队伍'
      },
      {
        text: '<span style="font-weight: bold;">亚超联赛——亚商2019年会</span>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '年会总是一年中大家最期待的一次大团聚。亚商人在这里，家人在这里。数九寒天的季节，大伙聚在一起汇聚的是2019年的能量。2019年，亚商如球队再出发，征战绿茵场，收获好成绩。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '',
        imgurl: 'ycls5.jpg',
        imgDetail: '亚商集团董事长陈琦伟先生为亚商人送上祝酒词'
      },
      {
        text: '',
        imgurl: 'ycls6.jpg',
        imgDetail: '亚商20多年的老友也亲赴现场'
      },
      {
        text: '',
        imgurl: 'ycls7.jpg',
        imgDetail: '高管们的祝福紧接着就到'
      },
      {
        text: '',
        imgurl: 'ycls8.jpg',
        imgDetail: '董事长率先士卒，“马仔”服高歌一曲'
      },
      {
        text: '',
        imgurl: 'ycls10.jpg',
        imgDetail: '真正激烈的还是展现技术的游戏环节'
      },
      {
        text: '',
        imgurl: 'ycls11.jpg',
        imgDetail: '<span style="font-weight: bold;">最期待环节：</span>颁奖 抽奖 筷子都放下'
      },
      {
        text: '',
        imgurl: 'ycls12.jpg',
        imgDetail: '多个现金红包：666、888、2019、大牌商品、实用家电；亚商在年会奖品上从不含糊'
      },
      {
        text: '',
        imgurl: 'ycls13.jpg',
        imgDetail: ''
      },
      {
        text: '<span style="font-weight: bold;">年会圆满 气势如虹——2019年，亚商再上新征程</span>',
        imgurl: '',
        imgDetail: ''
      },
    ]
  },
  {
    id: 8,
    title: '陈琦伟《关注民营企业新动力》',
    Publisher: '亚商ABC',
    time: '2018.11.16',
    content: [
      {
        text: '2018年也开始进入收官阶段了。再往后的发展，长久的发展、内力，只有靠企业家精神和能力的焕发，靠市场的决定性作用，靠政府审时度势的制度创新，才会为新的年份打开新局面，使得中国经济将来才会有一个坚实的基础，去站立在世界的舞台上，而不是建在沙滩上的大厦。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="text-align: center;"><video controls="controls" width="900" height="510" poster="http://www.abc-group.cn/public-image/2018-12-07-001.jpg">' +
          '<source src="https://media.abc-group.cn/abc-group/%E6%96%B0%E9%97%BB%E7%B1%BB%E8%A7%86%E9%A2%91/%E9%99%88%E7%90%A6%E4%BC%9F%E6%BC%94%E8%AE%B2%2000_00_06-00_15_18.mp4" type="video/mp4"></video></div>',
        imgurl: '',
        imgDetail: ''
      }
    ]
  },
  {
    id: 9,
    title: '亚商走进 · 第五届世界互联网大会',
    Publisher: '亚商ABC',
    time: '2018.11.09',
    content: [
      {
        text: '第五届世界互联网大会数字经济与资本市场融合发展对接会11月9日下午在浙江乌镇举办，上海交通大学安泰经济与管理学院教授，亚商集团创始人、董事长陈琦伟在主旨演讲中指出，在微观上，前段中国市场低迷下来，就是因为我们对上市公司的价值判断。因为上市公司是资本市场的微观基础，是细胞。价值判断上，我们一直缺少科学的手段。从数字经济的角度，我们完全有可能去利用大数据和人工智能更加专业的、科学的判断上市公司价值的状态。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="text-align: center;"><video controls="controls" width="900" height="510" poster="http://www.abc-group.cn/public-image/2018-11-23-001.jpg">' +
          '<source src="https://media.abc-group.cn/abc-group/%E6%96%B0%E9%97%BB%E7%B1%BB%E8%A7%86%E9%A2%91/%E9%99%88%E7%90%A6%E4%BC%9F%E6%BC%94%E8%AE%B2%2000_00_06-00_15_17.mp4" type="video/mp4"></video></div>',
        imgurl: '',
        imgDetail: '主题演讲现场视频'
      }
    ]
  },
  {
    id: 10,
    title: '亚商观点丨2018，经济转折，民企转机',
    Publisher: '亚商ABC',
    time: '2018.11.05',
    content: [
      {
        text: '亚商集团创始人、董事长陈琦伟先生的这篇演讲分享于十月下旬苏州的一个金融峰会上。当时用的主题就是“民企转机”。上周习总书记召开座谈会大力为民企打气赋能。所以我们特别整理并发出陈琦伟董事长的这篇演讲，与大家分享。',
        imgurl: 'jjzx.jpg',
        imgDetail: ''
      },
      {
        text: '<span style="font-weight: 600; color: #000;">2018，经济转折，民企转机</span>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="font-weight: 600; color: #000;">——陈琦伟</span>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '首先要祝贺吴江太湖新城金融小镇的发力。长三角历来是中国经济最富庶之地，富庶的根本原因在于民间活力。今年以来，弥漫在市场上或商界的，是一种焦虑情绪。但吴江这样的实践，体现出在面对挑战时，基层和民间的活力所在。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '我自己国庆前后在美国待了两个多礼拜。我带了一个企业家的代表团，在杜克大学、在华府和纽约跟美方商业金融学术界的专家进行了六场交流。回国后又参加了商界和专家们的一系列交流，很有体会感受。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="color: blue;">不同寻常的2018年</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '我想先分享的是，2018年已注定是中国经济进程，改革开放进程中一个非常不一样的年份。这个不一样，就是经济的大进程又到了一个转折点。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '亚商从20年前开始做PE，做了18支基金，和各个地方政府合作的基金大概有8支。第一个合作的是四川的成都市政府。在19年前，政府作为LP投资，由亚商来管，运作非常好。我们这支基金直接支撑了成都技术高新开发区的快速成名和发展。所以从这个意义上来说，地方母基金的设立，对地方今后，对未来的产业创新和发展肯定是有积极推动作用的。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '在座的，企业家也好、投资人也好、经济学者也好，是否亲眼见证过中国经济的转折之年。在历史上经历转折之年的时候，当时感触不一定深，但是回过头来看，转折很重要，转折才创造真正的面向未来的新动能和事业机会。从长远眼光看，偶然性比必然性对事业和人生的成功其实重要的多得多。你每天做事情常规的朝九晚五，每个月的工作计划，年度的工作计划，都是重复如此，说难不难，但是最难的是应付偶然，应付你没有预测到的事情。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '比方说，二十年前亚商在成都跟政府做PE基金支持科技产业发展，但那时候全国各地政府的主要精力不是在科技产业上，而是在土地开发和房地产上。成都市政府还是有远见，因为高校集中，科技力量也有，所以我们一合作就很成功。亚商的多个爆款企业都是那时投的，我们的投资回报率高的企业多数是在成都投出来的。那时候政府对科技和实业产业的重视远不如现在。而现在，土地财政基本上是强弩之末，所以政策转型已是必须，是真正要支持实体经济和创新经济发展的时候了。这就是应付或面对转折点，要开始面对与过去二十来年我们已经习惯了的，不一样的增长方式了。长三角地区与很多内地不一样，秋江水冷鸭先知，长三角还是做得领先的。这是我讲的今年的一个特点。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="color: blue;">改革开放40年</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '我们把视野放宽一点，从历史视野和更大的全球视野来看，我们中国经济也是面临一个转折性的、没有预料到的挑战。大家可以简单比较一下，今年年初的时候，包括两会期间，我们上上下下对经济的判断、论调、对国际形势的判断，都跟现在非常不一样了，年初或一季度前，乐观是主基调。现在回过头去看看。从年初到现在就遭遇了很多的意外，比如说中美贸易战。现在有一点看得非常清楚，可能越打越大。第一没有结束，第二还看不到什么时候结束，第三还是可能越打越大。那么这个事情就没办法小看，就要有新思维来应变。今年是中国改革开放四十年。改革开放四十年间，中国发展几大引擎，一个是改革释放了制度红利，另外一个重要的措施就是对外开放。我一生最感恩一个人，就是邓小平。邓公，他以他一人之力改变历史进程。如果不是他，中国不会有这般改变，小到恢复高考，大到彻底否定文革，改革开放；甚至九二南巡，中国90年代以后的发展。没有邓公，中国经济走老路是正常的，比如说计划经济为主。经济运营以政府为主，辅助一点市场的色彩。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '四十年的改革开放初期，邓小平确定了对美国友好。包括1979年打越南，从那以后中美建交和出国留学，向西方跨国公司（也就是大资本家）开放等等。八十年代最早一批的留美学生现在在中国的科技、金融市场，财经管理等方面都发挥着不可替代的重要作用。过去四十年，中国是从世界资本主义市场得益最大的国家。以亚商同苏州地区的交流合作为例。我们就体会到苏州、长三角地区的很多企业是以国际贸易为主，不光数量多，而且规模大，不少已在国际市场上占有龙头地位。因此，中国是过去几十年从世界市场得益最大的，是从全球国际贸易市场得益最多的国家。再者，中国主要是从美国得益。中国是从美国市场得益最大的国家。现在有一些我认为轻则无知，重则愚蠢的说法，比如我不买你美国大豆，可以买巴西的或者是哪里的。但你知不知道？美国的大豆质量最好、数量最多，价格最便宜，供货最可靠。你买巴西的，可能相当一部分还是来自美国再加价卖给你。我的意思不是说离开美国活不下去，一样活得下去，中国人的忍耐力是全世界证明过的。哪怕回到只要社会主义的草，不要资本主义的苗的文革，回到饥荒年代，也不是不能活，但值得吗？是对民族负责的选择吗？是符合常识的选择吗？当然现在的80后，90后并不一定知道什么是饥荒，你们可能从懂事开始就看到一个物资丰裕的社会，看到的是四通八达的高速公路上车跑来跑去，又有高速铁路，看到的是一个很富裕很有钱很牛气的国家。其实，看看你们身边包括你们的父母的很多行为习惯，喜欢争先恐后等等，都有饥荒时代的烙印。四十年前离我们并不是太远。所以，不能好了伤疤忘了疼。是开放和改革才使我们脱离贫穷的。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '这就很清楚了。因为事实上，中国从开放当中得益巨大，而且得益最多是从美国，中美贸易战打下去，对于中国经济肯定不利的。这也逼迫我们思考怎样做正确的事。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '今年开始注重科技和实体经济成为潮流，包括总书记几次三番提到的要注重自主科技的开发，包括越来越提起要支持民营企业的发展。这些非常好、非常正确的战略方向，都是跟外部环境变化有相当程度的关系。我的好朋友周其仁教授讲过，改革是逼出来的。从这个意义，今年中国高层的政策调整，我感觉，内外环境的倒逼，起了很大作用。中国还是要坚定不移的走邓公开创的改革开放之路。这个调整对中国的未来影响巨大，如果真调整到位，落实到位了，就是中国之福。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="color: blue;">民营企业家精神焕发</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '在改革开放四十年之际看到现在的转折之年，我们还值得重视第三个因素，就是除了制度性改革，从原来的计划经济转向市场导向的经济体系，对外开放以外，还有第三个因素就是民营企业，企业家精神的出现。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '中国在改革开放之初，包括里程碑意义的十一届三中全会公告，并没有一个词是提到支持民营企业，没有一个字提到要支持、鼓励企业家精神。八十年代中期出现了民营企业家，我看评选改革四十年，百位企业家把年广久评选进去了，“炒瓜子”进入到中国政协常委。一个人雇十几个人帮他炒瓜子，在当时的高层居然引起了巨大争议，这种争议讲给今天的年轻人听都觉得不可思议，那就是：马克思说过雇工超过八个就是资本主义了，因为产生剩余价值了，而用暴力革命把资本家剥削的剩余价值夺回到人民大众手中，是革命的道德依据。于是，高层的左派振振有词，年广久的案例就是资本主义复辟的案例，那按照革命年代的规矩，判刑是至少的，砍头也不是不可以的，因为他逆了天条了。但是，邓公的智慧才是真正体现了中国五千年文化的精髓。该缓就缓，该妥协就妥协，基本原则不变。当时年广久的事他就说了，你先放放让他试试。这一试，就试出了解决今天中国大部分经济增长和就业的民营企业阶层，功德无量啊。现在大家都清楚的事实是，民营企业已经对GDP增长，对就业和税收增长的贡献，超过国有企业，超过半壁江山。在这样的背景下，有任何论调，行为，去怀疑，甚至否定民营企业的主流经济作用，去给民营企业添乱，都是既不明智，又不符合我们国家的根本利益。可以这么说，中国面向未来的经济要再现辉煌，只有取决于民营企业和企业家的事业大成功，而不可能是任何其他原因。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '2018年也开始进入收官阶段了。再往后的发展，当下的一些刺激政策能管得了一时，长久的发展、内力，只有靠企业家精神和能力的焕发，靠市场的决定性作用，靠政府审时度势的制度创新，才会为新的年份打开新局面，使得中国经济将来才会有一个坚实的基础，去站立在世界的舞台上，而不是建在沙滩上的大厦。所以今年转折之年，特殊之年，非常值得大家期待在这样一个年份，上上下下都出现真正的制度创新和实干，以金融支持实体经济的发展。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '谢谢大家！',
        imgurl: '',
        imgDetail: ''
      }
    ]
  },
  {
    id: 11,
    title: '亚商金融沙龙丨底部价值区域投资机遇',
    Publisher: '亚商ABC',
    time: '2018.11.02',
    content: [
      {
        text: '秋意正浓但却阳光尚好，2018年快要步入尾声，在这样的时节，盘点这一年间的种种发生，搜罗各家观点，群英聚会，秋高论江湖。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '2018年10月30日，亚商金融沙龙研讨会又一次开展。来自国资研究院、银行、券商、保险、基金公司的40位专家学者、企业高管悉数到场。在闭门研讨会上，与会嘉宾们从各自所代表机构的角度出发，对《底部价值区域投资机遇》展开各种可能性的讨论。并对当下面对的问题和局面，给出自家实战中得到的经验和解决途径。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '30年亚商',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="color: #000; font-weight: 600;">研讨开题 陈琦伟</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '亚商集团创始人、董事长；亚商投顾创始人',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '国内经济整体进入下行周期，是L形，底部周期会走的比较长。安倍来访，国内部分人将经济寄希望于日本，但是国内经济是不能依靠外部去解救的。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: 'A股有港股化的趋势。港股有两千只出头，但一千多只没什么交易。部分小市值股票业绩很好，增速也不错，但就是没什么交易量。A股如果真那样的话情况可能更糟糕。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '股权质押是个导火索，背后是市场的萎缩。市场要在后面盘很长一段时间。底部区域下面如何淘金？很难，并且要很小心。关键还是要靠专业取胜。今天希望由各专业机构的专业人士充分讨论一下。谢谢大家莅临！',
        imgurl: 'jrsl.jpg',
        imgDetail: ''
      },
      {
        text: '<div style="font-weight: 600;color: #000; margin-bottom: -20px;">各家高手纷纷亮招各抒己见。</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="font-weight: 600;color: #000; margin-bottom: -20px;">由于闭门会议原因，在此为各位看官稍加披露。</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="font-weight: 600;color: #000;">看热闹，也看门道。</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="color: #000; font-weight: 600;">股权质押的风险</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="margin-bottom: -20px;">股权质押整体风险尚可，个股风险较大。目前质押融资比保持在1.94。近万亿跌破平仓线，72.5%跌破警戒线，中小板较多。</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '个股风险在于公司股权质押比例高、最危险的是接近平仓线到警戒线之间。解决方案：卖出、资金接盘司法诉讼冻结。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="color: #000; font-weight: 600;">股权质押场内外比较</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="margin-bottom: -20px;">场内/场外质押比较：场外可以做ST，场内不可以。场内质押标准化交易，交易方便，流动性比较高，因此规模成长快。</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="margin-bottom: -20px;">股权质押经历两轮快速增长，驱动因素不同：</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="margin-bottom: -20px;">1.13年二季度-15年二季度，质押率最高60% ——牛市，风险偏好比较高；</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="margin-bottom: -20px;">2.16年-17年末，快速增长 —— 市场表现低迷，金融监管收紧背景下，企业缺钱；</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '解决路径：引进国资，提供民企借款等',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="color: #000; font-weight: 600;">关于国资上市公司并购重组</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="margin-bottom: -20px;">国企不代表国资，不代表政府国资委，现在政企分开，国资企业是市场行为。国资产业投资让股权结构优化，看中的是背后产业，因此最后主体都会落在产业集团上。</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '国企是独立市场行为，未来两条腿走路：1.上市公司沿着产业；2.产业并购基金；打造国有平台，为国家在战略领域筹备；同时不影响二级市场行为，因为国企基本是二股东，非大股东。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="color: #000; font-weight: 600;">证券公司股权质押关注</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '股票质押存在逻辑性问题：<div>1.大股东股票缺乏流动性；</div><div>2.处置与否取决于资产价值，是否可以覆盖本息。</div><div>大部分没钱付本息的公司，往往是出现巨大问题，上市公司与大股东都出现问题。有客户找国资接盘，但面临：国资决策流程长/上市公司所在地迁址问题/支付方式导致大股东债务问题无法解决。</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="color: #000; font-weight: 600;">股权质押引致的壳交易机会</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '2014-2015因为产业发展不行，缺乏接班人等原因买壳；2015-2016善于资本运作的资本方买壳较多；2018，90%是因为债务压力被迫卖壳。<div>目前卖方和买方差异存在，如何解决差异是第三方合作的机会。</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="color: #000; font-weight: 600;">股权质押危机下的投资机遇分析</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="color: #000; font-weight: 600;">亚商投顾 副总 黄文佳</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div>亚商投资标的筛选标准主要针对于基本面优秀的产业龙头（50-200亿），选择的行业以大健康、大消费、高端制造行业等为主，企业到预警线、未到平仓线，股价已企稳，控股股东有产业合作意愿、亚商资源能够助力产业发展。</div><div>标的来源30年来积累的200多家上市公司客户，市值超过百亿的细分行业龙头上市公司。还包括地方政府推荐、行业协会遴选及券商质押部门商业银行推荐的优质上市公司。</div><div>亚商的投资决策流程更加苛刻，研究更深入、尽调更完善、投决更平衡。在投资方式上是股权投资为主，出资主题是基金投资，投资比例上5%以上。</div><div>亚商核心能力擅长以产业投资和增值服务为合作方大幅度提升战略价值，是中国资本市场诸多创新的首倡者与实践者。30年来已与十多个省市级政府和数百家大型企业集团、上市公司和优秀民营企业开展各类战略合作，提供专业服务。在过去20多年中操作过多起大型并购交易，涉及金额超过1000亿人民币。</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="color: #000; font-weight: 600;">沙龙的最后，本次研讨会发起方——亚商投顾为活动做了总结</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="color: #000; font-weight: 600;">沈毅亭 亚商投顾营运总裁</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div><span style="color: #FA8C16">一、</span>跳出金融，到产业资本的角度看问题。2008-2014年上海公司董、监、高增持做了回测，董、监、高中选了财务总监增持，绝对收益18%，相对收益26%年化。财务总监，属于40-50岁，女性居多，特别保守，10-12个月后出现高点。</div><div><span style="color: #FA8C16">二、</span>信息不对称，信息最充分的是实控人，第二类是董监高，第三类是产业资本，第四类是金融资本，第五类是散户。前三类产业资本定价最精准，但是买卖都不会在最高点，拿这个去看，短期来看可能有回撤，但是长期来看赚钱概率高。如果产业资本买价打三折，大概率还是会很安全。</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="color: #000; font-weight: 600;">于伟霞 亚商投顾合伙人</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div>当前股市大幅下挫主要是2个方面原因，一个是基本面，产业升级的痛苦和外部贸易战的影响，二是因为运动式去杠杆导致资金面紧张和信心流失，现在的新出的政策导向可能会缓解一些资金面紧张的局面，基本面因为产业升级和内外部环境影响，调整没那么快。这些上市公司，有一些本来就有很多问题，下跌是正常回归理性，但是在这个过程中，也有一些企业本身不错因为外部环境而错杀的，这些企业可以救，是我们的目标。我们各方协作，可以有一些好的方案出来，挖掘这些被错杀和低估的公司。</div><div>标的最难，产品不难。</div>',
        imgurl: '',
        imgDetail: ''
      }
    ]
  },
  {
    id: 12,
    title: '陈琦伟教授在2018中国发展高层论坛上发表专题演讲',
    Publisher: '亚商ABC',
    time: '2018.09.19',
    content: [
      {
        text: '2018年9月16日至9月17日由国务院发展研究中心指导，中国发展研究基金会主办的2018中国发展高层论坛顺利召开。大会以“中国：改革新征程 开放新境界”为主题，聚焦热点经济话题，盛邀国内外各界一流嘉宾，展开讨论演讲。亚商集团董事长陈琦伟教授在“崛起的中国消费市场”板块发表重要发言。',
        imgurl: '2018ltyj.jpg',
        imgDetail: '大会现场照片'
      },
      {
        text: '<span style="font-weight: 600; color: #000;">以下为陈琦伟教授的演讲实录：</span>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '“崛起的中国消费市场”这个话题本身很有时代意义。我相信对每年举办的中国发展高层论坛，应该也是有2018年特点的新话题。',
        imgurl: '',
        imgDetail: '',
        marksLeft: 'symbol-left.png'
      },
      {
        text: '亚商是专业的投资机构，在过去十几年中我们管理的十几支基金，包括新筹建的创新消费一直也关注消费领域。我愿意跟大家分享从投资人的角度怎么来看中国消费这个概念。在座的著名专家尼古拉斯·拉迪先生是在30多年前开始研究中国，那是中国经济开始快速增长的起点。首先是中国制造的年代，并且持续了二十多年，成为中国经济全球地位的标志。现在进入到“中国消费”，我们是不是准备好应对这个主题？这个题目背后的深层次的商业逻辑是什么。我想利用这个有限的时间跟大家分享。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '中国消费市场的崛起不是孤立的或者静态的商业窗口期，它是中国过去40年改革开放、30年的持续经济增长、财富增长的逻辑的结果。它是在经济发展过程中自然的进入到这个阶段，而不是任何预先的设计。也就是说中国过往取得的成就不是通过设计，而是通过改革开放的市场力量，以及社会发展的力量，从本源上推动的结果。政府的政策顺应潮流，符合了市场力量的趋势，才获得了巨大的成就。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '从这个意义上来认识中国消费市场的崛起，同样的逻辑是适用的。那就是经过“中国制造”带来的财富成功和财富积累，才使得“中国消费”的阶段得以出现。这点认识对于做投资来说很重要。因为这就意味着：“中国消费”的阶段还处于开始阶段，我们看到的中国人愿意花钱还只是个表面现象。这个花钱的演变趋势是什么？持续力怎么样？花钱对中国经济未来增长的意义到底在哪里？是不是“买买买”就可以带动中国经济继续持续增长？包括对投资来说，未来商业机会的影响是什么？这些问题我们还没有真正理性面对。所以我觉得这次中国发展高层论坛启动的这个题目，这是值得今后若干年，甚至很长时间研究的主题。',
        imgurl: '2018ltyj2.jpg',
        imgDetail: '陈琦伟教授正在发表讲话'
      },
      {
        text: '我跟大家分享一下我们对消费市场的剖析。我们觉得消费市场不是一个简单的板块。从今年国家已经公布的统计数据来看，2018年注定是中国经济发展历史上一个非常特殊的年份。中国经济是实质性的进入转型期、调整期。因为很多国内外因素的重叠。在统计数据上也反映出来。比如，现在GDP是保持稳定的增长，但社会零售总额在下降，最近几个月的下降还比较明显。但是，另外一方面，居民的消费支出在增长。这个数据矛盾背后有什么原因在里面。从投资的角度，我们寻找的企业也好，产品也好，一定要跑在正确的赛道上，他跑的方向在2018年以后是有实在的广阔的前景的，而不是在下降的通道。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '社会零售总额的下降有它的逻辑。其中很重要的一个现象，那就是全中国集团性的消费支出下降了。这个判断不难理解，因为企业消费支出是下降的，特别是民营企业，可以说可能是急剧下降。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '另外，从政府部门来说，从过往几年来看，政府的消费性支出是下降的，可能是因为诸如“八项规定”这样的因素吧。这部分采购是社会零售总额中有相当影响力的一部分，从而必然影响到供应端，换句话说，与这个板块相应的产品和服务供给会有相当一段时期的萎缩。这种萎缩一定会影响到相关的企业，包括我们的投资选择。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '而从另外方面看，现在大家耳熟能详的名词，像消费升级等等、与财富积累起来以后人们消费习惯的改变和新的习惯形成有关。例如中老年人更注重健康，养生和休闲型生活，80后、90后的人群更注重彰显个性和时尚的生活方式，全社会都对教育相关的消费更加重视等等，特别是互联网和大数据时代带来的信息冲击，对消费方式的革新变化具有爆炸性影响。这种很动态，很容易变化的现实，使得“中国消费”时代与传统的“中国制造”时代有着明显的不同，那就是波动性更大，更具有不确定性。或者从另一个角度看，无论是供应和消费，更加会有创新和变化的特点。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '比方说在年轻一代的心目中，过去5、6年他们可能受主流媒体影响已经形成了一个观念，就是中国已经是世界大国，而且中国经济还会持续高速增长。年轻一代基本上都愿意接受这个观点。他们认为既然持续成长，那么我会一直挣得到钱，所以我现在有钱就应该花掉，我要有自己的生活方式。但是，如果万一因为周期性或外部环境变化等等因素，中国经济增长减速，钱袋子紧起来了呢？花钱的习惯已经养成，但是钱要是少下去了？那么“中国消费”会是什么样的一个模式？对产业和市场和投资选择会是什么样的影响？这些复杂因素，才是我们今天看“中国消费”需要有前瞻性思考的内容。',
        imgurl: '2018ltyj3.jpg',
        imgDetail: '陈琦伟教授正在认真聆听其他嘉宾的发言'
      },
      {
        text: '因此，我们选择跟中国消费的未来密切有关的有投资机会的新领域时。非常注意刚才讲到中国消费不是成熟的概念，只是刚刚开始的新概念的特点。实际上，从长远来说，一个国家的经济持续增长不能只靠消费拉动。消费是经济调整期的过渡的阶段。中国能形成中国消费力，这是中国运气好，现在老百姓口袋里有很多钱，他们愿意消费。但是，这个消费力只靠口袋里的钱，它是会逐渐递减的。所以，更重要的是形成未来的持续的更加健康的收入来源，来支持社会消费趋势的持续增长。真正健康的世界大国，它的生产和制造之间是有平衡的。所以，真正以长远的眼光，我们还是需要在关注“中国消费”的同时，也关注因为中国经济结构变化而对未来的制造能力，也就是实体经济能力带来的影响和机会。投资既能满足当下的需求，更会引导未来的需求。近两年来美国经济的成功，就在于新的投资增强了供应端的能力。从世界经济的普遍规律来说，中国经济转型的成功，肯定最终依赖供应端新的增长能力的形成，这样的话，“中国消费”应该是一个过渡阶段，当然，这是一个螺旋式上升过程中的过渡阶段。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '把“中国消费”和“中国制造升级”联系起来，我们就会明白，真正重要的，是真刀真枪的深化改革，而不能因为我们现在口袋里有点钱，就自我感觉良好，以为就会自然继续过好日子。不改革，不创新，经济活力一定会不断萎缩！ 实际上，以我们这样的机构的观点来看，我们在赞赏和认同中国消费时代到来的同时，我们非常关注投资和中国制造这一端。实体经济的活力需要的就是创新，利用创新的投资、创新的制造来满足消费时代。这才是健康长期增长的逻辑所在。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '从创新投资来看，现在大家一般把它理解成民营企业是创新的主力军。在当下的经济形势下，民营企业的创新力其实在下降，值得政策制定者重视。另外一面，那就是当下占尽中国经济风光的国有企业，能不能形成内在的创新力，是直接关系到中国经济前景的重大问题。如果国有企业能深化改革，有创新力，中国模式才真正走的通，不然经济前景的挑战是很大的。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '谢谢大家！',
        imgurl: '',
        imgDetail: '',
        marksRight: 'symbol-right.png'
      }
    ]
  },
  {
    id: 13,
    title: '崛起的中国消费市场 之 赋能消费升级不同层面',
    Publisher: '亚商ABC',
    time: '2018.09.19',
    content: [
      {
        text: '由清科集团主办的2018中国创业武林大会于2018年9月18-20日在北京香格里拉大酒店举行。汇集各领域领先的知名投资人和创业者进行一年一度行业的灵思碰撞。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '亚商资本创始合伙人张琼女士应邀参加，担任消费专场主持人，引领同场嘉宾共话消费升级不同层面的赋能。',
        imgurl: 'zq1.jpeg',
        imgDetail: ''
      },
      {
        text: '<span style="font-weight: 600; color: #000;">以下内容为大会现场实录:</span>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '今天这个主题会特别有意思。最近热点比较多。譬如说前段时间像拼多多在美国上市，也是创造了一波热潮。包括像前天和昨天在北京钓鱼台国宾馆也开了一个由国务院发展研究中心主办的中国发展论坛。在这个论坛上面大家提到一个话题，说中国现在是不是民营资本有一种被挤出的现象。当然2018年也是比较妖的一年，整个宏观形势也不是非常乐观。所以大家都在说中国经济发展的三驾马车，投资、外贸、消费。外贸受到了挑战，消费能不能成为异军突起，去引领中国经济继续发展。',
        imgurl: '',
        imgDetail: '',
        marksLeft: 'symbol-left.png'
      },
      {
        text: '从去年开始就在说消费升级，但是到了今年大家都会有一种错觉或者一种感觉，现在类似像拼多多、趣头条、快手这样的企业发展非常快，是不是中国会面临一个中产陷阱，会陷入一个消费降级呢？那我们作为创业者和投资人是怎么看，到底是消费升级还是消费降级？',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="color: #ED7D31;">从没有品牌的地摊货到创立品牌的商品，这就是一种升级。</span>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '其实消费是永远在升级的，只不过它的上升是一个螺旋型的上升，或者是蛇型的上升，而不是直线上去的感觉。我经常开玩笑亚商资本算是投资界的老兵，第一支基金2000年就成立了，成立之初专注就是投资中国整个消费。因为中国13亿人口对消费的一种不断升级的追求，对生活方式的一种改善的追求，这个理念是永恒不变的。而在这样非直线型的消费升级中，有三个阶段是非常显著的：',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '第一，大家对品质、品牌的追求，不是说价高就是升级。但是在合理的价格范围里边，大家会追求更好品质的，更有品牌属性的这样一种商品，那我觉得这是体现的消费升级。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '第二，在消费的模式上升级，以前更多的是一种对产品的消费，现在可能会慢慢的从产品向服务，大家追求一种更多元化的，更加精细的一种服务的消费，大家更愿意在服务层面，精神层面的消费上面花钱。譬如旅游、文化、体育等方面的消费投入。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '第三，大家对消费的模式也在发生改变，比如说大家的理念。更多的从未来的发展、从环保绿色的观念去看，觉得如果我能够用一些共享的东西，能够分享，能够盘活。这本身不是一种消费降级，是对未来的一种态度。在这轮消费升级中，大家理念上已经发生了一些变化。',
        imgurl: 'zq2.jpeg',
        imgDetail: ''
      },
      {
        text: '<span style="color: #ED7D31;">如何寻求消费行业的明日之星</span>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '从消费升级的角度，可以从不同的一个层面去看到它怎么样做赋能。譬如说品牌，品牌怎么样重新定位和针对目标消费群体，怎么样去传达更新的内涵。譬如说技术、数据怎么样去引领整个消费的发展，包括我们一种新的商业模式。这种种其实都可以提供更多的赋能，来使整个消费不断升级。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '怎么样让消费者，让用户，对你的品牌喜爱程度，对平台的使用度，整个互动生命周期被延长，被深化，这样的话企业的发展就会更加长足。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '在未来，在一个大的消费品类里边也是可以产生跨界的。大的消费品类，有品牌生命力的——我觉得这个品牌本身也是需要不断地去升级和发展的——可能从它初期的定位到它业务发展上去，品牌的内涵本身也要不断地发生变化。还有不能忽视的就是大数据驱动的。这就意味着，能够把品牌内涵、渠道数据、文化跨界、互动体验全部整合在一起，那它可能就是未来消费里面的独角兽，或者未来的消费行业的明日之星。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '谢谢大家！',
        imgurl: '',
        imgDetail: '',
        marksRight: 'symbol-right.png'
      }
    ]
  },
  {
    id: 14,
    title: '陈琦伟教授受邀参加2018金融街88号论坛夏季峰会',
    Publisher: '亚商ABC',
    time: '2018.07.30',
    content: [
      {
        text: '7月26日，金融街88号论坛夏季峰会在沪召开，本次峰会由华夏经济学研究发展基金会、金融街88号论坛主办，论坛理事长单位平安银行、论坛副理事长单位大成基金和论坛常务理事单位理财周刊共同承办。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '本次峰会以“私募基金的机遇和挑战”为主题，有统计数据显示，我国私募基金行业发展呈现高速发展态势，截至<span style="font-weight: 600; color: #000;">5月私募管理规模增加了900亿元，总管理规模达到12.57万亿元，</span>创下历史新高。大资管行业，正面临着资产新规的实施所带来的机遇和挑战。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '私募基金市场如何取得快速发展？如何在发展体系建设、拓宽资金渠道、完善人才配套体系、退出机制等方面取得突破？如何与银行、公募机构相互赋能？',
        imgurl: 'jrj1.jpg',
        imgDetail: '2018金融街88号论坛夏季峰会现场照片'
      },
      {
        text: '在“2018金融街88号论坛夏季峰会”上，亚商集团董事长陈琦伟教授发表了重要的观点。作为资本市场元老级的人物，陈琦伟教授认为，中国经济长期来看是向好的，上市公司会越来越重视转型期的资本策略问题，包括“追求长期价值”、“并购精准化”等。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '除此之外，在“2018金融街88号论坛夏季峰会”上，论坛轮值理事长、建信养老金总裁冯丽英女士，论坛理事长、平安银行行长助理兼上海分行行长冷培栋先生，论坛副理事长兼学术委员会秘书长、大成基金总经理罗登攀先生，及论坛常务理事、理财周刊董事长陈跃先生分别发表峰会致辞。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="font-weight: 600; color: #000;">以下是陈琦伟教授的现场演讲实录：</span>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: `大家好，刚才好几位看到我，都说我是资本市场元老级的人物，上海证监会敲锣开业的时候我在现场，28年的时间，中国资本市场这么多变化，又面临这么特殊的时刻，感谢主办方能够邀请我这样一个亲历了中国资本市场28年的人士来分享我的看法。`,
        imgurl: '',
        imgDetail: '',
        marksLeft: 'symbol-left.png'
      },
      {
        text: '刚才王总的演讲我非常受益，王总是我很尊重的经济学家，像主持人介绍，我是1987年获得的孙远方经济学奖，后来阴差阳错创建了亚商，但是我对经济学家依旧是衷心的、尊敬的。因为我的很多朋友都是经济学家，所以刚才王总的观点我从专业角度非常同意。我本来准备的主题是上市转型的资本策略，王总的演讲让我很受启发，我必须从一个既不同又相同的角度稍微展开一下我的主题。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '首先一点我想讲，资本市场经历了几次大起大落，对于几个节点，2015年、2018年，我个人不参与二级市场，描述的不是很准确，但是几个大的节点大家都感受很深，作为历史事件经常会被提到。2015年初，2018年初，那个时候我们对发生这么大事件的预见性如何？总体来看我们得说基本上还是比较差的，一直到了2018年，我的看法绝对不是平常之年，2018年是标志性转折年，这一点我和王总讲的可能不一样，可能也是一样的，因为这两个关键因素上，一个是中央的经济政策，从去杠杆变成了稳杠杆，有人在年初的时候预计到了吗？在七月份的时候，中央改变这个政策，因为去杠杆是一个长期性的、深层次的、结构性的改革，一定要承受这个痛苦，要改清楚。现在一下子变成要稳杠杆，说明这是一个比较急剧的变化，这一点作为投资人要意识到，因为2018年很快会变成历史，到了2019年回过头看2018年，就会发现，2018年发生了一些急剧的变化，这是其中之一。',
        imgurl: 'jrj2.jpg',
        imgDetail: '陈琦伟教授在进行《上市公司在转型期的资本策略》主题演讲'
      },
      {
        text: '第二个就是贸易战，贸易战的深度影响，现在刚刚开始。有消息说昨天美欧、美日、欧日达成了零关税，不知道正式文件有没有颁布，但是逻辑上是可以成立的。这个超级自由贸易区的形成，到今天为止和中国没有关系，今天我们在中国企业家群里发了这一条，中国最依赖的是WTO的加入，因为中国经济取得今天的成就，WTO的加入至少起了50%，一半的作用。现在这个超级自由贸易区的形式，架构仍然存在，但是主要的玩家已经不愿意玩WTO了，我相信投资人有预见性，如果这是一个趋势的话，那就说明全球形势对中国不利只是刚刚开始。时间关系不展开讲了，我相信在座，我一直很赞赏资本市场的人，受教育程度高，智商高，能力强。最重要的是既能做好当下，又能真正看清远方。这两点因素不展开讲的意思是，观点已经讲出来，这两个长期因素对中国的不利影响刚刚开始。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '我们结构化调整，讲了多少年？2008年的时候就下大决心要做， 2015年的时候也认真鼓一下劲，但是中国的泡沫问题依旧存在，因为调整难，改革难，这次宽货币紧信用，从稳杠杆的角度来说，紧信用也会放开。当然和以往不一样的是，可能结构性的，先讲是讲，要相对定向的，但是实际效果会不会失真，咱们拭目以待。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '我四月份的时候在美国参加一个会议。美国商务部也是主要的支持部分，亚太商业峰会，一年一度，坐在我边上的是美国商务部长。当时贸易代表在上面发言，部长和我们讲，中美之间绝对不是一个贸易逆差数字的问题，是一个游戏规则调整的问题。这句话随着时间过去我印象越来越深。但是对这一点我们一直低估，我们以为就是一个数字问题，至少到现在为止，我们在政策上相对是被动的。做决策，被动决策的话，往往是处于不利的地位的。只有变成主动决策，才会变成局势可控。',
        imgurl: 'jrj3.jpg',
        imgDetail: '现场认真听讲的观众们'
      },
      {
        text: '总的是讲，因为到主动决策到真正可控还有一个过程，所以整个经济和市场的不确定性还是非常大的。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '但是我同意王总讲的一点，就是这一轮调整过程对股市是有好处的，这个好处是中国畸形的经济结构。中央财政政策部门在号召要脱虚向实，要鼓励实体经济，但是你一放水，首先得益的是泡沫，而不是下面的实体。这样的话我也同意房地产、金融部门、股市都会得益，这是不真实的消息。我昨天晚上碰到一个香港很重量级的金融人士，我们和他们聊天。他说内地的政策变化香港马上就反映出来了，地下钱庄往外走的钱集聚增多，前段时间世界杯期间赌球，公安部门打击地下钱庄抓的很严厉。亚商现在做一级市场投资，我们和上市公司和创业企业家接触的很多，实体经济的整体意愿非常低迷，持续低迷，继续低迷，只要他们掏的出来钱，能出去的尽量想出去。因此昨天晚上我听他们讲，我是觉得确实是印证了我们这个想法，因为从政府来讲，愿望是好的，希望放点水以后，让实体经济能够改善。当然了可以部分改善，但是还有相当一部分，因为原来的经济结构是靠行政手段干预市场，这种玩法，现在企业层面、市场层面，他们只会越来越精明，不会越来越笨。我听他们讲，真的是惊叹这种效率。所以我说这个政策的短期效益可以乐观，因为金融部门、资管市场，以后分化会越来越厉害，会首先得益。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '受王总的启发，我对这点宏观经济多评论了几句，讲错了是我自己认识不当，大家可以批评。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '接下来简单讲讲上市公司的资本策略问题，我们从1993年中国资本市场第一批收购兼并亚商就参与了。1993年中国证券市场发生了四起大规模收购A股股权的事件，我们亚商参与了三起，后来做了一级市场以后，对上市公司关注稍微少了一些。从前年开始，我们和这些上市公司高层，这些企业家都是朋友，大家聊起来觉得龙头企业到转型期，瓶颈现象非常明显。现在上市公司资本策略会越来越明显，这和二级市场关系不是太大，上市公司自身调整的问题。因为以往的年代，在泡沫过多的年代，特别是一些大泡沫的突然出现，对于市场的损害作用非常大，把人心都给带坏了。大家都觉得我只要编一个故事，我只要投机性强一些，会抓机遇，我就能得到好处，这个奖赏制度是非常明显的。因此以往的上市公司越做越投机，越做越泡沫化。但是我们现在大的逻辑就是这样，因为2018年是真正的转型之年，是经济不好的时刻真正开始的时候，对于专业投资人来说永远是机遇。但是长期来说，很多问题以后都会延迟爆发。现在爆的都是前几年的问题，现在如果继续放水，这些雷都掩盖掉了，但是雷还在那里，然后再增加新的雷，所以还会爆。因此真正聪明的上市公司，对于资本市场特别是资本策略的看法要真正有一个深度的改变，这个改变包括这样几个方面。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '第一，我觉得专业机构大有可为。从机构投资人的眼中，什么样的上市公司有持续的增长价值？这是第一线的很多上市公司高层，董事长总裁，他们想的不多的问题。他们自己懂产品懂行业，旁边的诱惑特别多。我们看到太多上市公司现在出现问题了，因为这些企业家本身蛮单纯的。创业一旦成功了，诱惑他去做房地产，诱惑他去玩资本。所以上市公司真正要有定力，来看怎么创造长期持续的价值。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '所以我们现在亚商做的一些案例，促进上市公司和投资人做深度沟通，很多私募基金第一线的经理都是年轻人，年轻人相对聚焦领域比较窄。上市公司要适应这一点，我们在促成上市公司和投资人深度沟通当中，这是中国资本市场当下一个很大的机遇。只要处于有利地位，他们都能够用这种不是投机的眼光，而是从投资人身上体会投资人的专业知识和专业逻辑和企业发展策略结合起来，这会产生一种良性循环，让上市公司的资本价值真正特点体现。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '其次就是收购兼并的精准化。以前的购并很容易是为了抓市场眼球，为了做大规模。实际上再往后，因为整个市场的结构性调整，所以收购兼并过程当中精准化专业匹配来引导上市公司做自己主业的调整。因为中国企业普遍的毛病是杂，比较杂，容易做杂。哪怕在一个主业里面，也容易覆盖面太多，通过收购兼并分拆这些精准的操作和以及投机性操作不一样，这对上市公司长期的竞争力和资本市场能力会有非常大的帮助。',
        imgurl: 'jrj4.jpg',
        imgDetail: '陈琦伟教授正在分享他的观点'
      },
      {
        text: '最后一点，我们体会到实际上。不要看我们现在，我们当下觉得政府调控的影响力很大，但是事实上正是在这种表面上政府调控能力最大的时候转机在出现，就是市场的力量在越来越起作用。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '现在很多企业，刚才我讲的，如果放水了很多钱往外走，这是一个市场选择，他们并不是说喜欢这个或者不喜欢这个，只是说怎么对这个资产最有利。但是从长期来说，企业本身自主行为会起作用。2018年也是一个转折之年，在最困难的时候，企业要把方法做对，特别是注重依托自己的核心业务、核心产业，主动做市场资源整合，我们强调几个自信，这是政府层面上。我觉得企业的自信，在这个最困难的时候是要提出来的，而且将来会证明，越来越有力量。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: `因此归纳起来讲，我要谢谢王总，王总给了我很多启发，中国从短中期来看会好，长期可能会有一段路要走，再长期，总要有一个转折点，这个转折点不完全由上而下，主动性的东西、企业自主的行为、市场的行为在里面会起重要的作用。再长期，我觉得中国还是看好，谢谢大家！`,
        imgurl: '',
        imgDetail: '',
        marksRight: 'symbol-right.png'
      }
    ]
  },
  {
    id: 15,
    title: '投资幸福西饼，创烘培新零售领域记录',
    Publisher: '亚商ABC',
    time: '2018.07.26',
    content: [
      {
        text: '7月25日，全国知名烘焙新零售品牌「幸福西饼」宣布完成4亿元B轮融资，亚商资本作为新投资人，由深圳亚商基金投资5000万元。本轮投资由华兴新经济基金领投，老股东美团龙珠资本、璀璨资本持续加码，亚商资本、信中利跟投，华兴Alpha担任独家财务顾问。值得关注的是，此次幸福西饼融资，也是烘焙新零售领域里最大单笔融资。',
        imgurl: 'xfxb1.jpg',
        imgDetail: ''
      },
      {
        text: '',
        imgurl: 'xfxb2.jpg',
        imgDetail: ''
      },
      {
        text: '',
        imgurl: 'xfxb3.jpg',
        imgDetail: ''
      },
      {
        text: '',
        imgurl: 'xfxb4.jpg',
        imgDetail: '融资发布会现场照片'
      },
      {
        text: '亚商资本合伙人郭锐表示，蛋糕市场空间巨大，但高度分散，缺乏有领导力的品牌。幸福西饼线上下单、线下工厂店制作配送的新颖模式既保证了产品品质，又极大的提升了用户体验。在所覆盖城市，可以做到2-5小时送达，竞争力明显。随着品牌地位的提升，在覆盖城市数量不断增加的同时，先进的合作模式让合作伙伴无后顾之忧，实现双赢。好的企业离不开卓越的团队，创始人袁总、姜总等扎根蛋糕行业十几年，经历了线下开店到互联网化的整个过程，具备非常强的学习能力。',
        imgurl: 'xfxb5.jpg',
        imgDetail: '融资发布会现场照片'
      },
      {
        text: '幸福西饼成立于2008年，最初定位是线下烘焙连锁品牌，2013年转型做互联网蛋糕，通过线上下单，线下中央工厂和分布式工厂配合并自建冷链配送团队，保证2-5小时送达，始终坚持「百分之百新鲜现做」。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '在与团队深入接触调研后，亚商资本迅速做出了投资决策，并以深圳市区两级引导基金参与的亚商诺辉基金作为主投基金，未来会积极寻求政府的支持与协作，一起携手，下一站更幸福！',
        imgurl: '',
        imgDetail: ''
      },
    ]
  },
  {
    id: 16,
    title: '专访陈琦伟：转型中如何把握精准投资机会',
    Publisher: '亚商ABC',
    time: '2018.07.17',
    content: [
      {
        text: '<div style="text-indent:0;color: #666;">原创：《首席对策》<br/>记者：李策<br/>摄像：杨晓 徐金根</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="text-align: center;"><video controls="controls" width="900" height="510" poster="http://www.abc-group.cn/public-image/zfcqw.jpg"><source src="https://media.abc-group.cn/abc-group/%E6%96%B0%E9%97%BB%E7%B1%BB%E8%A7%86%E9%A2%91/%E3%80%8A%E9%A6%96%E5%B8%AD%E5%AF%B9%E7%AD%96%E3%80%8B_%E4%B8%93%E8%AE%BF%E9%99%88%E7%90%A6%E4%BC%9F_20180713.Ogg" type="video/ogg"><source src="https://media.abc-group.cn/abc-group/%E6%96%B0%E9%97%BB%E7%B1%BB%E8%A7%86%E9%A2%91/%E3%80%8A%E9%A6%96%E5%B8%AD%E5%AF%B9%E7%AD%96%E3%80%8B_%E4%B8%93%E8%AE%BF%E9%99%88%E7%90%A6%E4%BC%9F_20180713.webm" type="video/webm"><source src="https://media.abc-group.cn/abc-group/%E6%96%B0%E9%97%BB%E7%B1%BB%E8%A7%86%E9%A2%91/%E3%80%8A%E9%A6%96%E5%B8%AD%E5%AF%B9%E7%AD%96%E3%80%8B_%E4%B8%93%E8%AE%BF%E9%99%88%E7%90%A6%E4%BC%9F_20180713.mp4" type="video/mp4"></video></div>',
        imgurl: '',
        imgDetail: '陈琦伟教授在接受采访'
      },
      {
        text: '<div style="text-indent:0;">【提要】<br/><span style="font-weight: 600; color:#000;">本期《首席对策》专访的是经济学家和投资实战专家：陈琦伟</span></div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '他是中国创业资本研究中心主任，“孙冶方经济学优秀著作奖”获得者，华东师大校董，上海证交所专家委员，曾任中国国家开发银行和多个省市政府顾问。除了拥有丰富的学术研究成果，他还是亚商集团创始人，董事长。亚商资本创始合伙人。亚布力中国企业家论坛理事，上海新沪商联合会轮值主席,多家金融机构和上市公司独立董事。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="font-weight: 600; color:#000;text-indent:0;">专业领域及成就：</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '投资银行和资本市场专家。在国内、外政府和商务界有广泛的联系。其专业代表作《国际竞争论》曾获“孙冶方经济学优秀著作奖”。其一系列实际操作的中国企业上市，上市公司收购兼并和重组以及VC和PE投资的案例，体现了洞察中国经济金融资本市场主流商业机会的前瞻力。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="text-indent:0;font-weight: 600; color:#007AAA">访谈摘要：</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '转型的新时代，由中国速度向中国质量转变，是新时代转型的重要内涵之一。资本，也就是投资，如何助推中国经济的转型升级？在转型过程当中，投资策略及其逻辑会发生怎样的变化？陈琦伟教授在《首席对策》中给出了独到的见解：转型以后，资本在挑企业的时候，会根据经济周期的特点，根据结构性变化过程中的机会，做更加精准的甄别。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="color: #000;font-weight: 600;">一，资产性的需求会总体放缓，而消费性需求在快速上升。结构性调整的基本特点与中国经济总量增大带来多方面的变化直接有关，</span>对于中国经济中间的反周期的这种领域，比方说像健康、消费、教育、环保、新能源等等，对专业性的要求跟以前大势普涨的时代相比较提高了很多，它就要求资本本身更加具有专业能力。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="color: #000;font-weight: 600;">二，精准投资的前提是精准的选择，这就要求对行业的聚焦、企业自身优势、投资时间窗口更加关注。</span>投资和商业机会进入一个长的向下趋势，难度在明显增加。但用精准化，专业化的眼光看，结构性机会反而在增长。换句话说，对于有自身核心优势的企业来说，未来是美好的。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="color: #000;font-weight: 600;">三，</span>科技因素会越来越明显，但这明显也是一种结构性的调整。<span style="color: #000;font-weight: 600;">以后做投资，有开创性技术或者有技术创新元素的商业模式，更加会受到青睐。</span>中国经济转型，摆脱传统增长方式，主要驱动因素要靠科技进步。所以从结构性变化趋势来看，科技因素是一个巨大的机会。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="color: #000;font-weight: 600;">四，</span>房地产可能还是有一定的增长速度，一方面空房率在大规模的提高，但总的趋势放缓已经是不争的事实。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<div style="text-indent:0;color: #007AAA;font-weight: 600;">以下是本期《首席对策》访谈文字实录：</div>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="color: #000;font-weight: 600;">第一财经 李策：</span>您好！您提到目前中国经济是转型的时代，我们由中国速度向中国质量转型发展，那么在这个转型过程当中，投资策略及其逻辑会发生怎样的变化？',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="color: #000;font-weight: 600;">陈琦伟：</span>中国过去20来年持续高速增长过程中间确实有大量新的资金投入，因为是大势普涨的时期，所以企业只要拿到钱，只要敢去做，一般成功的概率还是比较大的，但是现在转型以后，有一个最大的特点就是让投资的专业性显现出来了。本来这也是一个投资的本质，因为投资的实质是资本投入，资本是有一个价值判断的，因此转型以后，资本在挑企业的时候，它会根据这个经济周期的特点，根据结构性变化过程中间这种机会，它会做更加精准的甄别，这样就使得投资本身的价值功能也会越来越凸显出来。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="color: #000;font-weight: 600;">第一财经 李策：</span>对于结构性的变化，您认为“资产性的需求会总体放缓，而消费性需求在快速上升。”背后的逻辑是什么？新经济带动的投资有没有在资本市场上得以体现？',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="color: #000;font-weight: 600;">陈琦伟：</span>资产性的需求，其实再通俗点讲就是指大量的固定资产类的投资，包括基础建设、房地产、土地、厂房、设备，因为前20年，大家都清楚，是一个Made in China的，就是“中国制造”的一个大时代。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '所以那时候在这方面，包括整个中国基础设施的改善，这个投入的资本是巨大的。这个周期现在肯定很明显到了一个转折点，这个转折点以后，一方面过去这些领域的全面发展态势，以及它造成的泡沫要消除掉，所以它有一个退潮的过程，有一个收的过程。在收的过程中间，已经投入的资本本身有一个安全性的问题，保值的问题，就变成要解决一个存量的问题。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '经济周期带来另外一个机会就是它的增量，它的新增的部分，新增的部分就是结构性中间，它跟大经济周期相比较，它不是随着大势退潮，而是反而要发展的这样一些部门，这样一些领域，那么总的来看，中国经济中间的这种反周期的这种领域，比方说像健康、消费、教育、环保、新能源等等，所有这些领域有一个特点，它对专业性的要求跟以前大势普涨的时代相比较提高了很多，它就要求资本本身更加具有专业能力，包括创业企业本身，成长性企业本身在专业领域上的核心能力也要更明显。所以这样的话，这两者的结合就跟以前的时代相比较，要求就更加精准专业了，这样才有可能提高成功率，降低失败率。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="color: #000;font-weight: 600;">第一财经 李策：</span>除了投资标准发生了变化，在选择一级市场投资标的的时候，商业考量、商业模式是否也有趋势性的变革？',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="color: #000;font-weight: 600;">陈琦伟：</span>这个问题是个大问题，其实投资的企业是处于不同阶段的，亚商投的相对是成长期，或者是相对成熟一些的企业，在目前阶段，因为我们现在是觉得过去20多年的持续经济增长已经造就了一大批企业存量，就是有一批企业已经跑出来了，这批跑出来的企业目前就面临一个调整的问题，我们在投资策略上就要有几个标准，一个标准就是这个企业主业的核心竞争能力上要比较清晰和成功。一个很重要的，是企业核心团队在专业能力方面比较有明显的价值、竞争能力。第三个就是这种跑出来的企业需要比较注重它的短板在哪里，我们投资以后也帮助它来补好这个短板。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '换句话说，是相对精准的增值服务，不光投资金，而且帮他配资源，来解决他的短板。这是我们考量成熟企业的一些标准。但是我们也非常关注早期企业，因为早期企业，我们感到总体来讲，创业也好，早期企业也好，成功率是相对低的，失败率比较高，但是它一旦跑出来以后，这些企业往往代表着未来，而且做这些企业的都是相对年轻的企业家，他们哪怕有一些失败经历以后，对他们以后的成功也会有帮助，所以我们也很关注。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '我们对早期企业关注的焦点，首先是它所在的行业，他选择的行业，上面的空间有多大，也就是所谓的风口，风口要够大。风口不够大，企业成长的效率就不够高，所以行业很重要。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '第二点就是这个团队本身的特质，这个创始人以及核心团队，他们的专业，教育的知识结构、经历，个人的性格，特别是意志力，应付挑战的能力，因为创业企业会碰到很多失败。核心团队品质够优秀这点非常重要。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '第三个就是我们要看他的核心产品，或者核心服务方式，他们的优势有多明显，优势的潜力，通俗地讲，就是这块长板有多长，早期企业这个长板一定要长，而且要够长，而且要看得到它继续增长的潜力，这个非常重要，因为早期不是靠补短板，补短板刚才讲了是成熟企业的事情，早期企业一定要把它的优势部分要尽量快地发挥出来，就这三个要素吧，是看早期企业的。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="color: #000;font-weight: 600;">第一财经 李策：</span>在投资国际市场，海外市场的时候，有研究表明要选择与本国制度和文化相近的市场来投资，这样会减少很多冲突和矛盾，结合您对海外市场的投资经验，如何在对外投资方面趋利避害？',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="color: #000;font-weight: 600;">陈琦伟：</span>这是个很好的问题，但是前面的条件铺垫，我觉得不全面，第一，海外跟中国制度相近的国家几乎没有，所以这个前提不存在。中国制度，中国特色，只有中国有，你走出国门，现在全球通行的都是一个世界市场，都是一个市场经济规则，所以跟中国不完全一样，换句话说，也找不到你说跟中国相近制度跟文化。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '国外特别是欧美发达国家相对中国国内，从创业环境或者是企业经营环境来说，总体来说相对反而简单一些，因为国外一般规则比较清楚，它就是市场经济规则、法律，是很清晰的，所以因此在国外投资的话，购买资产也好，做企业也好，在法律环境、制度环境问题不是太大。难的是什么？是文化问题，就是我们要理解当地的文化，可能不能那么简单化。在国外要注意的，法律环境按照西方的，就现代市场经济环境就可以，在文化上，文化价值观上要意识到我们跟人家的差异，多尊重人家的，那就会更好一些。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="color: #000;font-weight: 600;">第一财经 李策：</span>在您讲的对于资本市场展望的基础之上，您多次提到新经济、以互联网+ ，分享经济委为代表的新经济取代了传统的旧经济，那么在新旧经济交替的过程中有没有出现新的投资机会？',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="color: #000;font-weight: 600;">陈琦伟：</span>现在很明显，新经济现在是一个大趋势，当然前两年跑的也是有些快了，然后大潮退潮，灭掉一大批企业，像前几年的O2O也好，像这几年的其它的比如说数据化、智能化，甚至最新的区块链等等，大家知道这是一个新方向，先往里冲，这个调整过程正常的。但我觉得新经济，总的趋势势不可挡。它会对以后结构调整里面发挥实质性的作用，这个趋势还是很重要，值得关注的。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="color: #000;font-weight: 600;">第一财经 李策：</span>在大众创业、万众创新的鼓舞之下，很多年轻人去创业，现在有种讨论叫“创业那些坑。”对于目前的创业环境和年轻人创业问题，您有哪些思考？',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="color: #000;font-weight: 600;">陈琦伟：</span>创业是一个大众化的，接地气的这样一项商业活动或者经济活动，它不是一个高大上的事，接地气的事不管什么阶段，做创业都是面临着很多坑，它跟什么阶段做没关系，以前在中国经济都好的时候，你去做创业，当然你如果运气好，相对成功率可能稍微高一点，但是你还是会碰到很多坑。到现在，进入转型期了，创业碰到的坑就会更加多一些，这是正常的。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '第二个就是刚才你讲到比如创业家面对着不可确定的现实，怎么样冲过去，这个是蛮有意思的问题，我的观点，我觉得早期创业者不必要考虑太多，不大可能有太理性的考虑，要敢冲，就是你通过所谓的雷区，或者是陷阱比较多的区域的时候，包括在大海里面你碰到急流的时候，这时要快速通过很重要，要敢冲，不要想太多。冲不过去，有的时候运气不好，那也没办法。像我一个同行做创业投资的大佬，他就讲他创业家已经失败过两次，再经过反思，到第三次创业的时候成功率会提高。我赞同这个看法。所以一开始创业的时候要敢冲，非常重要。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="color: #000;font-weight: 600;">第一财经 李策：</span>也就是说我们在对外投资方面，要与企业自身的竞争力形成良性互动，不能够只是简单地只看收益，要考虑全球风险及贸易保护主义，结合整个外围市场的变动，您认为全球投资环境对新兴市场会造成了什么样的影响？',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="color: #000;font-weight: 600;">陈琦伟：</span>这么说吧，现在整个国外的大环境，世界市场大环境其实对中国不是很有利的，实际上是一个退潮的时期，欧美是毫无疑问，我们要有一个调整期，表面上是贸易逆差大了，或者是贸易不平衡了，实际上他们觉得中国在遵守游戏规则方面有问题，特别是诚信守约。所以欧美市场对我们会有一个收潮。其它的发展中地区其实也不是那么乐观，因为发展中国家地区，包括我们周边邻居，包括我们“一带一路”所经过的地区，有很多有一个很大的问题，就是他们这些国家的经济社会的稳定性还不如欧美，所以也是有利有弊。总体来说，海外投资进入一个艰难时期，不大容易了。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="color: #000;font-weight: 600;">第一财经 李策：</span>您的意思是海外投资艰难，那么对于国内的股市 ¬楼市汇市 您是如何看待的？',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="color: #000;font-weight: 600;">陈琦伟：</span>你这提了两个有趣的问题，股市说句实在话，倒真的是宏观经济的反应，美国的股市一直涨，中国的股市一直跌，觉得这个好像不合理，其实反映了一个问题，就是我们中国经济过去成功的地方掩盖了我们的缺点，我们这个高楼是盖的很高，但我们的地基不牢，下面可能是沙滩，或者我们的地基没有打穿那个沙层奠基到岩石上，所以现在就碰到问题了。当然最好的结果就是我们赶紧调试这个地基，加固地基，然后把这个楼给扶正，那是算大吉了。这个调整期是一个很长的过程，因此股市反映了这样一个调整期的特点，大家对不确定性的一种判断和行动。',
        imgurl: '',
        imgDetail: ''
      },
    ]
  },
  {
    id: 17,
    title: '亚商集团董事长陈琦伟教授担任张家港市“引才大使”',
    Publisher: '亚商ABC',
    time: '2018.07.04',
    content: [
      {
        text: ' 6月30日下午，张家港市召开“引才大使”座谈会。中国科学院院士、超导电子学家吴培亨，中国工程院院士、应用光学专家姜会林，亚商集团董事长陈琦伟等专家教授汇聚一堂，为港城发展献计献策。市委副书记、市长黄戟参加活动。',
        imgurl: 'zjgzt.jpg',
        imgDetail: '市委副书记、市长黄戟为陈琦伟先生颁发证书'
      },
      {
        text: ' 会上，各位“引才大使”对如何推动张家港市营造创新创业生态环境，促进产业集聚、资本融合发展等方面畅所欲言，提出意见建议，并就下一步合作进行洽谈交流。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: ' 黄戟提到，聘请“引才大使”，是张家港市新时期推进招才引智工作的一项创新举措，希望各位“引才大使”发挥好桥梁纽带作用，介绍张家港、推荐张家港，让更多的人尤其是科技界、企业家、投资界的朋友了解张家港、认知张家港。同时，也希望“引才大使”发挥自身影响力和人脉优势，为张家港招引、集聚创新创业人才，帮助张家港选准产业发展方向，加快推动实现高质量发展。',
        imgurl: '',
        imgDetail: ''
      },
    ]
  },
  {
    id: 18,
    title: '亚商集团董事长陈琦伟教授参加复旦大学管理学院2018创投峰会',
    Publisher: '亚商ABC',
    time: '2018.07.03',
    content: [
      {
        text: '2018年7月1日，由复旦大学管理学院校友创业与投资俱乐部和复旦大学EMBA创投协会联袂打造的创投峰会在管理学院李达三楼隆重举行。复旦大学管理学院陆雄文院长、周健常务副院长、孙一民副院长与创投圈的资深人士共同出席了本次峰会。亚商集团董事长陈琦伟先生、证大集团董事长戴志康先生、深圳市东方富海投资管理股份有限公司董事长陈玮先生、上海国际集团资产管理有限公司董事长邓伟利校友、复荣集团董事长范思桦校友、美味不用等创始人陆瑞豪先生、酒仙网董事长郝鸿峰先生以及火山石资本创始合伙人章苏阳先生等嘉宾出席了峰会。',
        imgurl: 'zjg1.jpg',
        imgDetail: '活动现场照片'
      },
      {
        text: ' 本次峰会的与会者均为管理学院在投资领域工作或在各行各业创业的优秀校友，大家通过聆听创投圈大咖的倾情分享，进一步加深了对投资与创业的认识。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: ' 在“企业家说”环节，亚商集团董事长陈琦伟先生则围绕“聪明的钱与聪明的公司”这一主题，分享自己对“双创”的看法。陈先生认为，创业创新及其相关的资本活动会成为中国经济未来的一个主流，但创业的风险很高，创业家的个人性格、特点、意志力判断是很重要的环节。钱与企业的关系就像鸡和蛋的关系，资本在现代信息体系当中才是真正的母鸡。在精准性创业和精准性投资的时代，承诺和守信尤为重要。',
        imgurl: 'zjg2.jpg',
        imgDetail: '陈琦伟教授进行主题演讲'
      },
      {
        text: ' 本次峰会不仅为关注创投领域的校友带来新鲜的资讯与观点，启发校友们的进一步思考，也预示着管院校友们的实践将会为创投界带来新希望。相信通过管院校友的相互沟通与交流，能够利用集体智慧，共同打造在创业与投资领域中的复旦特色。',
        imgurl: '',
        imgDetail: ''
      },
    ]
  },
  {
    id: 19,
    title: '亚商三十周年庆典暨2018年度策略大会圆满结束',
    Publisher: '亚商ABC',
    time: '2018.06.11',
    content: [
      {
        text: '岁月如歌，风霜如画，三十年弹指一挥间，上海亚商发展集团有限公司迎来了30周岁的生日。三十年前，亚商是中国资本市场专业服务的第一推动力；三十年后，亚商是中国投资界的传奇和标杆。三十年，亚商是中国资本市场绕不过去的一个符号，一个响亮的名字。亚商的存在体现了一种“道”，以专业、诚信、创新和创始团队的家国情怀，始终与中国的资本市场的改革和中国的经济转型紧相随、共发展。亦步亦趋，时起时伏。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '为了庆祝这一特殊的日子，2018年6月8日，以“30与时共舞”为主题的周年庆典暨年度策略大会活动在上海国际会议中心隆重举行。',
        imgurl: '301.jpg',
        imgDetail: '会场全景照片'
      },
      {
        text: '<div style="text-align:center;">此次活动的主要嘉宾有:<br/>第十二届全国人民代表大会财政经济委员会副主任委员 重庆市原市长 <a href="https://baike.baidu.com/item/黄奇帆/7117495?fr=aladdin" target="_blank" style="font-weight: bold; color: #666;">黄奇帆</a><br/>上海市人民政府参事室主任 十二届全国政协常委 <a href="https://baike.baidu.com/item/王新奎" target="_blank" style="font-weight: bold; color: #666;">王新奎</a>、<a href="https://www.ecnu.edu.cn" target="_blank">华东师范大学</a>党委书记 <a href="https://baike.baidu.com/item/童世骏" target="_blank" style="font-weight: bold; color: #666;">童世骏</a>、<a href="http://www.zjs.com.cn" target="_blank">宅急送快运股份有限公司</a>监事会主席 <a href="https://baike.baidu.com/item/陈显宝" style="font-weight: bold; color: #666;">陈显宝</a><br/><a href="http://www.lavianacorp.com.cn" target="_blank">乐威医药股份有限公司</a> 董事长兼CEO <a href="#" style="font-weight: bold; color: #666;">陈文霆</a>、<a href="http://www.ruckerpark.com" target="_blank">上海洛克公园</a>创始人 <a href="#" style="font-weight: bold; color: #666;">戴富祺</a>、<a href="http://www.sig-am.com" target="_blank">上海国际集团资产管理有限公司</a>董事长 <a href="#" style="font-weight: bold; color: #666;">邓伟利</a><br/>家世界集团&<a href="https://www.plgolf.cn/Home/Index" target="_blank">太平洋高尔夫联盟</a>创始人 <a href="https://baike.baidu.com/item/杜厦" target="_blank" style="font-weight: bold; color: #666;">杜厦</a>、<a href="http://www.aj.com.cn" target="_blank">上海爱建股份</a>党委书记 <a href="https://baike.baidu.com/item/范永进" target="_blank" style="font-weight: bold; color: #666;">范永进</a>广州九龙湖房地产开发有限公司董事长 <a href="#" style="font-weight: bold; color: #666;">冯地</a><br/><a href="http://www.vantone.net" target="_blank">万通控股</a>董事长 <a href="https://baike.baidu.com/item/冯仑" target="_blank" style="font-weight: bold; color: #666;">冯仑</a>、<a href="http://www.shzfzy.com" target="_blank">上海中房置业</a>董事长 <a href="http://www.shzfzy.com/about.html"  target="_blank" style="font-weight: bold; color: #666;">桂国杰</a>、<a href="http://www.chinachant.com" target="_blank">广东长青(集团)股份有限公司</a>董事长 <a href="#" style="font-weight: bold; color: #666;">何启强</a><br/>上海新华商金控集团总裁 <a href="#" style="font-weight: bold; color: #666;">何志光</a>、<a href="http://www.cnhu.com" target="_blank">浙江新和成股份有限公司</a>董事长 <a href="https://baike.baidu.com/item/胡柏藩" target="_blank" style="font-weight: bold; color: #666;">胡柏藩</a>、<a href="http://www.gdptsh.com" target="_blank">福建莆田商会</a>名誉会长&<a href="http://www.hengyitz.com" target="_blank">上海恒奕投资管理有限公司</a>董事长 <a href="#" style="font-weight: bold; color: #666;">黄开添</a><br/><a href="http://www.galasports.net" target="_blank">GALA SPORTS</a>深圳市望尘科技有限公司CEO <a href="#" style="font-weight: bold; color: #666;">贾小东</a>、<a href="http://www.tcl.com" target="_blank">TCL集团</a>董事长 <a href="https://baike.baidu.com/item/李东生/7086914" target="_blank" style="font-weight: bold; color: #666;">李东生</a>、<a href="http://cairc.cn" target="_blank">中国保险养老社区联盟</a>会长 <a href="#" style="font-weight: bold; color: #666;">李钢</a><br/>原上海证券交易所上市部总监 <a href="#" style="font-weight: bold; color: #666;">李京真</a>、来恩生物医药公司联合创始人与首席执行官 <a href="#" style="font-weight: bold; color: #666;">李烈涛</a>、<a href="http://www.cifi.com.cn" target="_blank">旭辉集团</a>董事长 <a href="https://baike.baidu.com/item/林中/9273303" target="_blank" style="font-weight: bold; color: #666;">林中</a><br/><a href="http://www.zxbk.com.cn" target="_blank">正信银行</a>行长 <a href="#" style="font-weight: bold; color: #666;">刘向东</a>、<a href="http://www.shhuayi.com" target="_blank">上海华谊集团</a>党委书记、董事长 <a href="https://baike.baidu.com/item/刘训峰" style="font-weight: bold; color: #666;">刘训峰</a>、工银安盛保险董事长 <a href="#" style="font-weight: bold; color: #666;">马健</a><br/><a href="http://www.shufe.edu.cn" target="_blank">上海财经大学</a>原党委书记 <a href="https://baike.baidu.com/item/马钦荣" target="_blank" style="font-weight: bold; color: #666;">马钦荣</a>、<a href="http://www.ccxi.com.cn/cn" target="_blank">中诚信集团</a>董事长 <a href="https://baike.baidu.com/item/毛振华" target="_blank" style="font-weight: bold; color: #666;">毛振华</a>、<a href="http://www.jpinvestment.cn" target="_blank">钜派投资集团</a>联席董事长兼CEO <a href="https://baike.baidu.com/item/倪建达" target="_blank" style="font-weight: bold; color: #666;">倪建达</a><br/>原上海市委宣传部部长 <a href="https://baike.baidu.com/item/潘维明/18734683#viewPageContent" style="font-weight: bold; color: #666;" target="_blank">潘维明</a>、<a href="http://www.pingan.com" target="_blank">中国平安集团</a>总经理 <a href="https://baike.baidu.com/item/任汇川" target="_blank" style="font-weight: bold; color: #666;">任汇川</a>、原<a href="http://www.ccxi.com.cn/cn" target="_blank">华远集团</a>董事长 <a href="https://baike.baidu.com/item/任志强/4212957" target="_blank" style="font-weight: bold; color: #666;">任志强</a><br/><a href="http://www.skyherb.cn/cn/" target="_blank">浙江天草生物股份有限公司</a>董事长 <a href="#" style="font-weight: bold; color: #666;">邵云东</a>、美林阁集团董事局主席&莫泰酒店创始人 <a href="https://baike.baidu.com/item/沈飞宇/953335" target="_blank" style="font-weight: bold; color: #666;">沈飞宇</a>、原中共上海市委研究室主任 <a href="https://baike.baidu.com/item/孙恒志/12720786" target="_blank" style="font-weight: bold; color: #666;">孙恒志</a><br/><a href="http://www.yicai.com" target="_blank">第一财经</a>财务总监 <a href="#" style="font-weight: bold; color: #666;">孙峥</a>、<a href="http://www.chinaequity.net" target="_blank">信中利资本集团</a>创始人&董事长兼总裁 <a href="https://baike.baidu.com/item/汪潮涌" style="font-weight: bold; color: #666;" target="_blank">汪潮涌</a>、华东师范大学副校长 <a href="https://baike.baidu.com/item/汪荣明" target="_blank" style="font-weight: bold; color: #666;">汪荣明</a><br/><a href="http://www.stonecapital.com.cn" target="_blank">磐石资本</a>董事长 <a href="#" style="font-weight: bold; color: #666;">王力群</a>、原<a href="https://www.sjtu.edu.cn" target="_blank">上海交通大学</a>海外教育学院执行院长 <a href="http://www.fulihui.com" target="_blank">娃哈哈福礼惠</a>董事长 <a href="https://baike.baidu.com/item/王红新/10769659" target="_blank" style="font-weight: bold; color: #666;">王红新</a>、<a href="http://www.juneyao.com" target="_blank">均瑶集团</a>创始人 总裁 <a href="https://baike.baidu.com/item/王均豪" target="_blank" style="font-weight: bold; color: #666;">王均豪</a><br/>原<a href="https://www.htsec.com/ChannelHome/index.shtml" target="_blank">海通证券</a>董事长 <a href="https://baike.baidu.com/item/王开国/4494148" target="_blank" style="font-weight: bold; color: #666;">王开国</a>、<a href="http://www.xinhushang.org" target="_blank">新沪商</a>大商学院院长 <a href="#" style="font-weight: bold; color: #666;">王仁定</a>、<a href="https://www.anxintrust.com/new/" target="_blank">安信信托</a>董事长 <a href="#" style="font-weight: bold; color: #666;">王少钦</a><br/><a href="http://www.inmix.vipcom.cn" target="_blank">北京明通四季科技有限公司</a>创始人 <a href="#" style="font-weight: bold; color: #666;">王笙</a>、<a href="http://www.vkc-partners.com/cn" target="_blank">嘉御基金</a>创始合伙人兼董事长 <a href="https://baike.baidu.com/item/卫哲/8941973?fr=aladdin" target="_blank" style="font-weight: bold; color: #666;">卫哲</a>、原高盛合伙人&CXC创投董事长 <a href="https://baike.baidu.com/item/徐子望/10502972?fr=aladdin" target="_blank" style="font-weight: bold; color: #666;">徐子望</a><br/><a href="http://www.saifpartners.com.cn" target="_blank">赛富亚洲投资基金</a>创始管理合伙人 <a href="https://baike.baidu.com/item/阎焱" target="_blank" style="font-weight: bold; color: #666;">阎焱</a>、<a href="http://www.beingmate.com" target="_blank">贝因美集团</a>董事长 <a href="#" style="font-weight: bold; color: #666;">袁芳</a>、<a href="http://www.gf.suzhou.gov.cn/index.htm" target="_blank">苏州国发集团</a>总经理 <a href="https://baike.baidu.com/item/翟俊生/20248247" target="_blank" style="font-weight: bold; color: #666;">翟俊生</a><br/><a href="http://www.handnice.com" target="_blank">浙江恒励置业集团有限公司</a>总裁 <a href="#" style="font-weight: bold; color: #666;">张甬江</a>、<a href="http://www.tnc.org.cn" target="_blank">大自然保护协会</a>亚太区首席代表&<a href="http://tongdaocapital.com" target="_blank">道同资本</a>创始合伙人 <a href="https://baike.baidu.com/item/张醒生" target="_blank" style="font-weight: bold; color: #666;">张醒生</a>、<a href="https://www.stepholdings.com" target="_blank">上海创业接力科技金融集团</a>董事长 <a href="#" style="font-weight: bold; color: #666;">张德旺</a><br/><a href="http://www.opg.cn" target="_blank">东方明珠集团</a>总裁 <a href="http://www.baike.com/wiki/张炜[上海东方明珠新媒体股份有限公司总裁]" target="_blank" style="font-weight: bold; color: #666;">张炜</a>、<a href="http://www.adfaith.com" target="_blank">正略集团</a>创始人&董事长 <a href="https://baike.baidu.com/item/赵民/6791183" target="_blank" style="font-weight: bold; color: #666;">赵民</a>、<a href="http://www.cjland.com.cn" target="_blank">长甲集团国际控股有限公司</a>董事长 <a href="#" style="font-weight: bold; color: #666;">赵长甲</a><br/><a href="https://misscandy.world.tmall.com" target="_blank">杭州莱凡网络科技有限公司</a> CEO <a href="https://baike.baidu.com/item/赵明/19347353?fr=aladdin" target="_blank" style="font-weight: bold; color: #666;">赵明</a>、<a href="http://www.shanshan.com" target="_blank">杉杉集团</a>创始人&杉杉控股董事局主席 <a href="https://baike.baidu.com/item/郑永刚/9161153" target="_blank" style="font-weight: bold; color: #666;">郑永刚</a>、<a href="http://www.ehousechina.com/index" target="_blank">易居（中国）控股有限公司</a>董事长 <a href="https://baike.baidu.com/item/周忻/5414557"  target="_blank" style="font-weight: bold; color: #666;">周忻</a><br/><a href="http://www.whcccco.org" target="_blank">世界运河文化城市联盟</a>主席 <a href="#" style="font-weight: bold; color: #666;">朱民阳</a>、原<a href="http://www.ebchina.com/ebchina/index.shtml" target="_blank">光大集团</a>董事长 <a href="#" style="font-weight: bold; color: #666;">朱小华</a>、<a href="http://www.vstarcap.com/html/home" target="_blank">源星资本</a>董事长&管理合伙人 <a href="https://baike.baidu.com/item/卓福民" target="_blank" style="font-weight: bold; color: #666;">卓福民</a>等。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '现场还邀请了企业来宾、LP、合作伙伴、老员工等，参会人数将近400人，可谓怀旧与展望同行，事业与人生共勉的一场大派对。',
        imgurl: '302.jpg',
        imgDetail: '亚商老员工合影'
      },
      {
        text: '本次活动可以分三个篇章。第一个篇章“思想盛宴”中，各演讲嘉宾分别上台演讲，带领大家回顾了中国的产权改革、中美贸易战、国际竞争、企业家创新精神。第二个篇章“三十而立”中，精心制作的亚商三十年历程短片，让在场的每一位来宾都心潮澎湃，对亚商崭新的未来充满希望。之后，上海市人民政府参事室主任&十二届全国政协常委<a href="#" style="font-weight: bold;  color: #666;"> 王新奎 </a>先生，带着他的最新研究跟我们分享最前沿的经济研究。并且，在《面向未来 资本赋能》主题活动中，多位怀揣着梦想的创业者来到亚商三十周年大会现场，为大家展示他们打磨多时已有成绩的项目，其中不乏已十分耳熟能详的品牌。',
        imgurl: '303.jpg',
        imgDetail: '上海市人民政府参事室主任&十二届全国政协常委王新奎先生演讲照片'
      },
      {
        text: '第三个篇章“社会担当”中，亚商集团与华东师范大学日前达成合作，共同成立的“金融科技研究院”在本次庆典中举行仪式正式揭牌。当屏幕上因亚商集团董事长<a href="#" style="font-weight: bold;  color: #666;"> 陈琦伟 </a>教授、华东师范大学党委书记<a href="#" style="font-weight: bold; color: #666;"> 董世骏 </a>书记、亚商集团联席总裁及亚商资管董事长<a href="#" style="font-weight: bold; color: #666;"> 陈儒 </a>先生和华东师范大学副校长<a href="#" style="font-weight: bold; color: #666;"> 汪荣明 </a>校长的手纷纷按下了启动仪式的手掌印，霎那间电光火石，现场的气氛又一次推向了高潮。',
        imgurl: '304.jpg',
        imgDetail: '华东师范大学金融科技研究院揭牌仪式现场照片'
      },
      {
        text: '随后华师大合唱团和上海爱乐乐团的演出让所有人即追忆了亚商二十周年庆典为汶川地震救援人员举行的慈善之夜，又在一首首悠扬高雅的世界名曲中迎来了晚宴前最后的重量级嘉宾第十二届全国人民代表大会财政经济委员会副主任委员、重庆市原市长<a href="#" style="font-weight: bold; color: #666;"> 黄奇帆 </a>先生。黄奇帆市长给大家带来了他对三十年间中国经济的深刻理解。',
        imgurl: '305.jpg',
        imgDetail: '第十二届全国人民代表大会财政经济委员会副主任委员&重庆市原市长黄奇帆先生演讲照片'
      },
      {
        text: '筚路蓝缕，以启山林。三十而立，五段转型。百亿亚商，一众菁英。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '一九八八到二零一八，一万多个日日夜夜，记录了亚商砥砺奋进的五段转型。往事历历，群英岌岌。三十年有多少的人进人出，雪泥鸿爪；有多少的故事新篇，永留心间。三十年再聚首，笑忆过往，更待明朝。',
        imgurl: '',
        imgDetail: ''
      },
    ]
  },
  {
    id: 20,
    title: '亚商集团执行董事陈勉一受邀在上海嘉兴商会发表主题演讲',
    Publisher: '亚商ABC',
    time: '2018.06.05',
    content: [
      {
        text: ' 2018年6月3日，集团执行董事陈勉一先生受上海嘉兴商会邀请出席在外滩W酒店举行的上海市嘉兴商会青年企业家联合发展委员会成立大会，并发表了《投资、转型、升级——新经济形势下青年企业家对策》的主题演讲。',
        imgurl: 'cM1.jpg',
        imgDetail: '陈勉一先生演讲现场'
      },
      {
        text: ' 陈勉一先生首先结合当今中美贸易战、中国制造2025、经济去杠杆等国内外宏观形势对于未来整体经济趋势的影响进行了分析，随后就青年企业家如何通过对外投资和对内转型升级在新环境下与时俱进发表了精彩观点。',
        imgurl: 'cM12.jpg',
        imgDetail: '陈勉一先生正在演讲中'
      }
    ]
  },
  {
    id: 21,
    title: '陈琦伟教授受邀担任“陆家嘴资本夜话”系列讲坛嘉宾做主题报告',
    Publisher: '亚商ABC',
    time: '2018.05.25',
    content: [
      {
        text: ' 5月22日晚，由陆家嘴金融城发展局、上海市银行同业公会，上海市基金同业公会、上海市上市公司协会、上海市股权投资协会、上海支付清算协会、上海互联网金融行业协会、中国金融信息中心共同举办，钜派投资集团、有鱼普惠联合主办的“陆家嘴资本夜话”系列讲坛第八期在中国金融信息中心举行。本期讲坛以“精准投资与中国经济转型升级”为主题，特邀亚商集团董事长、上海交大安泰经管学院教授陈琦伟先生作题主题报告。',
        imgurl: 'cls-yj1.jpg',
        imgDetail: ''
      },
      {
        text: ' 主题演讲：',
        imgurl: 'cls-yj0.jpg',
        imgDetail: '亚商集团创始人、董事长，亚商资本创始合伙人陈琦伟'
      },
      {
        text: '<span style="font-weight: 600;">陈琦伟简介：</span>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text:'亚商集团创始人、董事长，亚商资本创始合伙人。亚布力企业家论坛理事，上海<a href="http://www.xinhushang.org" target="_blank">新沪商</a>联合会轮值主席。<a href="https://www.sjtu.edu.cn" target="_blank">上海交通大学</a>安泰经济与管理学院教授，中国创业资本研究中心主任，兼任中国国家开发银行顾问，上海证券交易所专家委员等。研究领域投资银行和资本市场，其代表作《国际竞争论》曾获“孙冶方经济学优秀著作奖”，实际操作了一系列中国企业上市，上市公司收购兼并和重组以及VC和PE投资的案例。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="font-weight: 600;">以下为演讲实录：</span>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '回想中国二十几年持续高速增长，中国经济有一个特点--很大很复杂。这样谁都可以对中国的问题评头论足，发表一番观点。这和美国、日本、西欧甚至韩国等其他工业国家截然不同。它们的特点--经济问题是政府和专家的事情，是一个相对专业的问题，一般老百姓只对就业和工资水平感兴趣。比如，中国北京的出租车司机会评论时政，美国，德国的租出车司机就不会。<span style="font-weight: 600;">这个区别，说明真正的经济发达的国家，它的经济问题是一个相对专业的问题。</span>在中国，人人可以评头论足，那也从一个方面说明我们经济的现代化程度实际上是不够的。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '这一点就跟我今天讲的精准投资有关系。历史上国内外因为经济周期而使发展有所停顿很正常，哪怕中国改革开放以后，也有过至少两次整顿。但现在，一方面大家都感觉到中国经济问题不小，但另一方面，中国经济这辆了高速公路的大车，虽然发现很多毛病，却没办法停下来检修了，只能边开边修，变得停不下来。<span style="font-weight: 600;">这个情况，应该说是很不一般。</span>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '我有幸参与了上个世纪八十年代的经济改革过程中的一些事关顶层设计的研究工作。那个时候中国经济也有一大堆问题。但车没那么大，没那么重，于是可以停下来检修。但这二十年下来，中国已经成为世界第二大经济体，换句话说世界第二大车了，一个又大又重又带病开了这么久的车，停起来就难了，很多问题的解决不得不往后延了，产生了很多复杂性。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '在这样的背景下，精准投资变得特别有意义。投资的基本元素是资本，因此我们就从资本的角度来看看中国经济的转型和升级。我先提出一个命题是，因为中国的发展太快太粗糙，因此一直没有真正搞清的一个基本概念，<span style="font-weight: 600;">就是什么是“资本”这样一个看上去不是问题的问题。</span>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '1990年12月19日上海证券交易所建立，敲锣开市的那一天，上市的八只股票是没有国营企业的，因为当时的主流观点认为国有企业缺钱的话自然有政府财政和国有银行支持，所以证券市场这样的地方，可以让符合条件的非国有企业去找钱。直到现在，各地政府把更多的上市公司数量作为本地政绩的挂钩指标，隔了二十多年，大家还是认为上市就是找钱，这个观念基本没变。中国基本没有经历西方现代商业社会进化历程，从农业社会一步跳进现代化，还是简单的把资本当钱来看。因此哪怕到了投资时代，大家也很简单理解——投资就是要将来被投企业上市实现投资回报，完成钱的游戏。<span style="font-weight: 600;">这种对资本的认识极大地限制了中国在现代化过程中对现代经济要素真正的价值力。</span>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '像我们这种年龄的人还知道以前有过饥饿时代、物资匮乏的时代。但很多90后从懂事开始就出生在一个有钱的国家，他们看到的是财富的持续增长。跟他们讲饥饿时代，他们觉得理解不了，理所当然认为我们是一个大国，是一个强国，是一个富国。但事实上，中国的财富是这二十年里面暴发式涌现和实现的，我们的观念，灵魂，还没有跟上来，还没有真正像马克思讲的那样，意识到在特定生产方式中，钱会具有资本的属性，而资本的灵魂就是能创造新价值的。这跟农民式的理解钱不是一回事了。<span style="font-weight: 600;">资本跟钱，虽然形式上都是数字，实际是完全不一样的东西。</span>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: ' 正因为这样，<span style="font-weight: 600;">资本才会成为一种主义，一种是跟市场经济联系在一起的创造新价值的机制。它内含着很多现代文明的元素，首先就是契约精神。</span>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '契约精神的实体化，就会形成一个组织构架，也就是现代企业。现代企业的最核心特点，就在于它是由一堆契约组成的。公司法，公司章程组成了企业的法律形态；公司各项制度和议事，决策，管理，风控程序，又组成了企业运营的游戏规则；企业的各种对外业务合同，则构成了这家企业的商业业态。哪怕是科技创新，世界的科技进步和创新源源不断，是因为大量的资本去支持了它。但这种支持的长效机制，不能是光给科技研发，那只是研发的费用，还形成不了资本。只有等这些成果跟一个组织形态--企业结合起来了，资金嫁接到企业的构架上面，融合在一起变成资本，它就变成具备自身创造机制的能力。<span style="font-weight: 600;">它就具备乘数效应的创造价值的能力。</span>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '中国真正开始比较多的做PE投资应该是十年前，然后六七年前就变成全民PE了，大家比较容易把它看成一个套利的机会，却忽略或不懂投资是让那些钱放进去以后跟企业组织形态产生化学反应，让商务模式的价值呈现几何级数量成长，这才是投资的本质。知其然又知其所以然就能做的更好。至少可以少犯错误，不犯大错误。我们对资本的本质理解透了，<span style="font-weight: 600;">在选择投资标的的时候，更加关注钱和它的商务模式结合以后产生的效应，而不是简单被发财效应诱惑，这就是精准投资的立意所在。</span>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '中国经济现在面临的困难前所未有，因为我们经济的规模和积累的问题都到了一个前所未有的地步。再加上现在外部环境出现了一些不利的变化。',
        imgurl: 'cls-yj2.jpg',
        imgDetail: ''
      },
      {
        text: '<span style="font-weight: 600;">一、房地产可能还是有一定的增长速度，一方面空房率在大规模的提高，但总的趋势放缓已经是不争的事实。</span>很多地方政府在第一线很真实的感受到问题出在哪里，因为现在土地财政收入急速下降，这是没法扭转的趋势。现在地方政府要鼓励公司上市，因为这是一个看得清楚的、可以快速带来财政收入的渠道。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="font-weight: 600;">二、制造业方面。</span>我跟民营企业家接触比较广泛，凡是碰到的第一线的企业家，充满热情、积极扩张实业投资的只占小部分，相当一部分是不得不维持或者心生倦意。我们碰到的案例，一代创业做传统行业，二代接班想接班的比例连10%都不到。所以中国的转折可能来得比所有人想象中要快。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="font-weight: 600;">三、资源环境依赖性产业。</span>过去二十年持续快速增长的另一个明显副作用就是对资源和环境的透支，现在大家都意识到这是难以为继的。在这方面，在相当一段时间里面，应对未来的挑战主要靠政府政策的引导，以及资本，企业界的共同努力。这种转型，也是一种价值创造。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="font-weight: 600;">下面谈谈结构性的变化。这是非常明显的趋势，资产性的需求会总体放缓，而消费性需求在快速上升。</span>目前来看，政府层面意识到了这种趋势，但在实务角度力度还没真正显示出来。我很同意我所尊敬的周其仁教授的观点，大象感冒了，它要吃药，喂它吃药就不能用我们平常的汤勺子来喂，这个量不对。汤勺是人感冒了喝药用的，这是一头大象，所以用药的力度非常重要。因此在政策层面，可能很多事情，想对了也看对了，但还需要做对，需要有执行力度。',
        imgurl: 'cls-yj3.jpg',
        imgDetail: ''
      },
      {
        text: '<span style="font-weight: 600;">结构性调整的基本特点与中国经济总量增大带来多方面的变化直接有关，包括消费型需求在上升。</span>从结构角度来说，它会提供很多机会，今天就不展开讲了。与结构性调整相关的另一点是地区上的差别，发达地区和欠发达地区的差距正在拉大。这种结构性的变化，它会引导资本投入的变化。这里我讲的资本都是指市场性的资本，不是指政府的投资。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '至于海外市场，应该坦率承认，<span style="font-weight: 600;">中国是从世界市场得益最大的国家。</span>2002年，我在洛杉矶参加了一个会议，它的主办方叫国际政策委员会，与会者多是研究亚太地区的西海岸的专家学者，以及从华盛顿退休下来的一些老政客。参加会议的一共约三十来人，只有我是中国人。这三十多人里面有两个美国前国务卿，一个是里根总统时期的国务卿，一个是克林顿总统时期的国务卿。美国人在会议上提出了一个主题，中国加入WTO后，美国市场上中国制造的产品大量出现。因此可以得出两个判断，第一，改革开放使中国正在从这个世界经济体系中得到好处，而且好处会越来越多。第二个判断，世界市场体系是现代资本主义体系里面最有活力的一个机制设计，它其中一个功能，就是用完全市场化的竞争使得后进的国家能够实现超越。所以在历史上，十九世纪以后，出现了美国超越英国，德国超过欧洲其他国家，日本崛起，亚洲四小龙崛起等等。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '这次中美的摩擦，中国是做了实质性的让步，中国不想打，这是对的。但世界市场对中国不会更友好，这个趋势刚刚开始。这个世界市场跟二十年前中国商品蜂拥而入，靠廉价、靠许诺的投资就能打开的时代不同了。<span style="font-weight: 600;">海外市场变化带来的压力，使得我们必须进行下一步经济转型和调整。</span>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '科技因素会越来越明显，但这明显也是一种结构性的调整。我们现在的精英层年轻化，教育程度又高，经历了中国稳定的发展时期，所以对很多事情的认识确实是很精准很到位的。在高端技术上，我们要立足自身，当然也要参与国际分工，这一块市场今后的空间是巨大的。<span style="font-weight: 600;">我们以后做投资，有开创性技术或者有技术创新元素的商业模式，更加会受到青睐。</span>中国经济转型，摆脱传统增长方式，主要驱动因素要靠科技进步。所以从结构性变化趋势来看，科技因素是一个巨大的机会。',
        imgurl: 'cls-yj4.jpg',
        imgDetail: ''
      },
      {
        text: '最后要讲一讲转型时期里的一个重要因素，就是突变因素——“黑天鹅”和“灰犀牛”。灰犀牛是看得见的巨大的风险，黑天鹅是看不见的、突然冒出来的风险。这个大时代并不安分，中美之间的博弈只是刚刚开始。中日韩、台海、南海，我们周边的环境突变因素很多，美国的变化因素也在某种程度上具有不可预测性。这些都可能成为未来经济形势、社会形势中的突变因素，从投资角度看都是需要加以考虑的问题。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="font-weight: 600;">现在来讲讲精准投资的问题。</span>以前为什么会出现为投资而投资，这跟经济发展的大形势有关系。因为以前市场发展得太快，提供的机会太多。就像房地产行业，在前二十年中至少有十多年，你只要拿了地做房地产，十有八九都能赚钱，并不取决于你有没有房地产专业背景。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '在精准投资的模式下，资本本身对价值实现的功能更加关注，在结构性的分化中，机会的出现不是普遍性的，而且不再占大部分比重了。<span style="font-weight: 600;">所以精准投资的前提是精准的选择，这就要求对行业的聚焦、企业自身优势、投资时间窗口更加关注。</span>',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="font-weight: 600;">精准投资的几个核心能力中，第一就是聚焦。</span>你要选择正确的方向，因为以后的投资方向，不是所有的都能赚钱，而是大部分不容易赚钱了。在能赚钱的那小部分里面，也需要甄别出来真正有发展潜力的商业模式。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="font-weight: 600;">第二个核心能力，是和头部企业合作的意识。</span>现在进入资本行业的新人，很多在产业认识上先天不足。比如在陆家嘴地区上班的年轻人，大量都是学校毕业以后就来做投资了，对实体经济缺乏感觉，对行业、产业的判断力不足。所以跟行业的头部企业合作，这是一个有效率的方法。因为行业头部企业的企业家们是真正实干的，他们对行业的理解远远比一般投资机构透彻。当然，企业家的认识不是全部，在这个之上还有创新和新的技术趋势，二者可以互补，所以要进行合作。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="font-weight: 600;">第三个核心能力是定制化。</span>因为合作的对象是一个经济实体，和它之间产生一种新的模式，会有一个比较长的过程。而如果跟头部企业合作的话，从实现资本的投资收益来说，就更加有保障。投资定制化和头部企业本身的发展，包括商业模式本身的价值实现，要求有更加精确的设计。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="font-weight: 600;">第四是智慧化。</span>最近几年，智慧化是一个非常明显的积极因素。虽然市场的困难程度在增加，但因为互联网的进步，智能化、智慧化的趋势，一些脱颖而出的商业模式和企业获得了明显的机会。如果我们做精准投资，能把智慧运营的能力结合进去，这将是一个正确的做法。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '<span style="font-weight: 600;">最后一个核心能力就是退出导向，也就是投资周期要缩短。</span>一般的投资周期是5+2年左右，而本土人民币的投资周期不会延长，只会缩短。真正的资本运作就要把退出途径看得尽量清楚，要有多种选择，这个非常重要。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '作为总结，可以这么说，用以往的传统眼光来看，投资和商业机会进入一个长的向下趋势，难度在明显增加。但用精准化，专业化的眼光看，结构性机会反而在增长。换句话说，对于有自身核心优势的企业来说，未来是美好的。',
        imgurl: '',
        imgDetail: ''
      },
    ]

  },
  {
    id: 22,
    title: '亚商集团执行董事陈勉一先生出席第12届中国投资年会',
    Publisher: '亚商ABC',
    time: '2018.04.25',
    content: [
      {
        text: ' 2018年4月25日，在投中信息主办的“第12届中国投资年会·年度峰会”上，亚商集团执行董事陈勉一先生作为嘉宾应邀参加了由BU集团举办的《BU新青年专场》主题活动并在大会上致词，会场气氛热烈。作为此次大会的压轴论坛，亚商集团应邀参与到本次活动可谓别有深意。',
        imgurl: 'bup1.jpeg',
        imgDetail: ''
      },
      {
        text: ' 亚商深耕中国资本市场30年，是市场诸多创新的首倡者与实践者，并逐渐成长为中国本土最优秀的具备产业整合和金融资本战略性运作能力的资本集团之一。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '亚商集团对于中国的经济、企业、行业发展和特色商业文化有着深刻而独到的理解，始终领行业风气之先，同时在投资过程中注重被投资企业的持续成长能力和未来资本市场溢价，作风稳健，业绩辉煌，收获广泛赞誉。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text:'BU是“青年领袖聚合平台”，以独特视角传递青年人的大投资视野和态度。当今中国，青年企业家作为新经济业态的生力军，在全球经济与社会发展面临创新变革的时代，凭借自身的管理能力与创新精神正在成为发展的骨干力量，新时代的“国之脊梁”。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '',
        imgurl: 'bup2.jpeg',
        imgDetail: ''
      },
      {
        text: '以下是大会演讲及陈勉一先生的发言记录：',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '首场主题演讲：《 转型与传承中青年企业家的价值探索》',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: 'BU集团董事长陈豪先生在专题演讲中分享道：',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '今年，是改革开放的40周年，我们这一代80后是受益者。2008年，我们刚走上工作岗位的时候，社会对这一代年轻人有着很多误解。汶川地震后，80后的表现，展现出了新一代人的社会责任感和精神面貌。那之后，我发起成立了“接力中国”，聚集中国最早期民营企业的接班人，服务于社会。如今，我们从7个创始人发展到现在的200多个会员。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '由此可见，十几年的时间里，青年企业家已经成为新经济、新中国重要的组成力量。我们，见证了青年企业家的崛起和成长。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '对比美国前十年最佳企业的组成，之前是以金融和医疗为主，而现在是以科技为主。在企业转型的过程中，中国企业还有很大的空间。新一代企业家有很好的教育背景，而青年企业家具有的的共享意识、共享精神使之更为开放，更加融合。2016年，我们在大的环境下做了一些尝试和探索，成立了BU集团。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: ' 首先，是要经营好自己的事业。BU大部分成员都来自于实业，在产业的基础上，我们帮助成员在转型升级中不断提升。第二，是把企业经营过程中的成果更好地转化。我们依托产业和资源平台的优势做了探索和研究，形成了今天BU财富和相关解决方案。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '“共享经济 - 共享平台 - 共享精神”是组成新时代青年企业家的核心价值理念；创新、创业，正在成为青年企业家创造财富的主要领域；经营企业与投资，也正在成为青年企业家财富创造的主要方式。最后，陈豪先生以一句名言与大家共勉：新时代是奋斗者的时代！',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '主旨演讲：《 实业背景下的产业投资实践》',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '会议上，盛山资产创始合伙人甘世雄先生也做了名为《 实业背景下的产业投资实践》的主题演讲。他说，今天的主题本身就是创新。BU是个典型的例子，你们能把优秀青年的创新基因联结聚合在一起，非常不容易。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '我本人最喜欢投技术创新，我的感触是----科学家不是企业家，如果联想不是由柳传志牵头，也不会发展成为今天的联想。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '技术专家做企业家容易出现技术自负、蔑视管理、独享心态、拒绝授权等情况。100个技术企业家中，具备企业家能力的不超过10个。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '优秀创业者要具备三种能力与气质，我喜欢的类型是鲨鱼苗，比如陈总和BU成员们；再就是有靠山，这里靠山指的是行业资源。第三是老兵新传，要不断挑战自己、超越自己。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '在“BU新青年专场”的互动环节中， BU财富CEO宋亚杰先生作为圆桌对话的主持，与大众国际董事兼总经理杨一清先生、宇海发展集团董事长凌超先生、长甲控股执行董事赵宏阳先生、亚商集团执行董事陈勉一先生、源星昱瀚董事长卓星煜先生、易麟投资管理合伙人卞怡菁女士、恒泰华盛合伙人张科先生7位嘉宾进行了深度的交流。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '',
        imgurl: 'bup3.jpeg',
        imgDetail: '陈勉一：亚商集团执行董事'
      },
      {
        text: '亚商集团执行董事陈勉一先生分享道：',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '现在，虽然资本赋能已经成为一个行业的共识，但对此概念理解上的“简单粗暴”，还是大有人在。我分享一个小故事，1992年上交所开张时，我父亲出席了开幕仪式。他背后坐着一个国企领导，他说今天8家公司都是民企，拿不到贷款才跑到股票市场交易——现在，反过来了，有些企业家认为只要股票一开锣，钱就自然进来了。这都是认识上的偏颇。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '在活动的互动环节里，各位嘉宾根据各自的理解出发，共同探讨了实业背景下的产融结合，以及青年企业家如何在传承、创新，以及如何平衡企业家的个人价值与社会责任等热门话题。现场，充满了活跃思想碰撞和充满真知灼见的智慧分享。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '时间很快过去了，结束铃声响起的时候，嘉宾们和在场的观众都感到意犹未尽。好在，亚商的精彩总在持续不断地呈现出来。',
        imgurl: '',
        imgDetail: ''
      }
    ]
  },
  {
    id: 23,
    title: '看到更加稳定、更加开放的中国——亚太商业展望会议聚焦中国经济的挑战和机遇',
    Publisher: '亚商ABC',
    time: '2018.04.19',
    content: [
      {
        text: '',
        imgurl: 'news-cqw.jpg',
        imgDetail: '陈琦伟教授在研讨会上 （图片来源：侨报记者夏嘉摄）'
      },
      {
        text: '在洛杉矶市中心4月16日举办的第31届亚太商业展望会议上，来自亚太地区和美国的学界、商界以及政界代表再一次将目光集中在了亚太地区，尤其是中国的经济发展上，中国的经济改革和贸易问题则成为本次会议讨论的焦点。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '由南加州大学马歇尔商业学院（Marshall School of Business）和美国商务服务部（U.S. Commercial Service）共同举办的第31届亚太商业展望会议周一在洛杉矶市中心万豪酒店（LA Grand Hotel）举行，活动汇集了50多位学界、商界和政府代表来讨论亚太地区的贸易和投资。前美国驻中国大使骆家辉（Gary Locke）为大会进行了名为《改变中的中国社会》的主题演讲，讨论美中贸易以及中国社会面临的挑战和机遇等。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text:'中国成为这次会议的重中之重，包括美国驻中国使馆的高级商务官员格里芬（Cynthia Griffin）在内的美国政府官员对中国的经济的现状和未来进行了分析，包括中国创业资本研究中心主任陈琦伟教授、哈佛亚洲中心高级研究员奥维尔霍特（William Overholt）在内的中美学者也对中国经济所面临的挑战和机遇作出了深度的剖析。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '中国创业资本研究中心主任，亚商集团董事长陈琦伟教授在谈到中国的经济现状时指出，在过去40年中，中国的领导层在决定加入WTO、发展监管权威机构、鼓励创业以及年轻一代创新的政策上作出了正确的判断。现在中国决策者已经意识到世界市场已经不像从前，出口面临的阻力越来越大，中国应该集中精力发展本国的市场。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '陈琦伟教授认为，尽管中国的未来面临很多挑战，但是绝大部分的中国人都希望看到更加稳定、更加开放的中国。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '亚太商业展望会议主要放眼亚太不同国家和地区的经济和贸易发展现况，经济专家和贸易问题方面的学者和政府官员对其发展进行分析和展望，为致力于亚美贸易的企业、商家提供相关的信息和政策咨询。这次会议探讨的主题包括美国与亚太地区的贸易挑战、政策变化对贸易的影响等，会议还针对中国、日本、泰国、印度尼西亚、越南、新加坡、新西兰和澳大利亚等不同的国家和地区举办小组讨论。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '【侨报记者夏嘉4月16日洛杉矶报道】',
        imgurl: '',
        imgDetail: ''
      }
    ]

  },
  {
    id: 24,
    title: '亚商电子竞技赛-春季团队赛',
    Publisher: '亚商集团编辑',
    time: '2018.04.16',
    content: [
      {
        text: '越塔强杀，瓜皮走位，亚商月月赛的电子竞技春季团队赛又回来了！',
        imgurl: 'news-wz1.jpg',
        imgDetail: '游戏现场实况转播'
      },
      {
        text: '本次赛制为5V5三局两胜制，亚商资管和亚商资本的两支队伍本着友谊长存的基本原则，开始了一番搏命厮杀~比赛历时2个半小时，激战正酣时楼外狂雨暴风电闪雷鸣。',
        imgurl: 'news-wz2.jpg',
        imgDetail: '全体参赛人员合影'
      },
      {
        text: '最后恭喜亚商资本团队赢得比赛冠军，比赛成绩2:1。',
        imgurl: 'news-wz3.jpg',
        imgDetail: '冠军团队及一血队员合影'
      }
    ]
  },
  {
    id: 25,
    title: '亚布力论坛理事张家港行',
    Publisher: '亚商集团编辑',
    time: '2018.04.02',
    content: [
      {
        text: '三月的张家港，花团似锦，春意盎然！3月30日，由亚商资本牵头联合主办的，以“新时代苏南模式升级创新”为主题的亚布力论坛理事张家港行暨第四届“港城合伙人”峰会在美丽的暨阳湖畔--产业资本中心隆重举行。',
        imgurl: 'news-cover.jpg',
        imgDetail: ''
      },
      {
        text: '活动邀请到40余位亚布力论坛理事代表及国内知名企业家代表，以及张家港市上市企业、新三板挂牌企业、创新创业企业的优秀企业家代表，共300余位来宾出席。张家港市市委书记朱立凡,市委副书记、市长黄戟出席了活动。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '市委书记朱立凡在致辞中对活动的举办表示了热烈欢迎',
        imgurl: '',
        imgDetail: ''
      },
      {
        text:'围绕“新时代苏南模式升级创新”主题，亚布力论坛原名誉主席刘明康, 全国人大财经委员会原副主任委员、重庆市原市长黄奇帆，康得投资集团、康得新集团董事长钟玉、汉德资本主席蔡洪平，<a href="http://www.saifpartners.com.cn" target="_blank">赛富亚洲投资基金</a>创始管理合伙人阎焱，<a href="http://tongdaocapital.com" target="_blank">道同资本</a>创始合伙人张醒生，长江润发董事长郁霞秋，张家港农商银行董事长季颖等8位重量级嘉宾进行了精彩的主题演讲，解读时势热点和趋势，碰撞思想智慧和火花，提升资本战略视野，明晰转型发展之路。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '在“港城合伙人”结对环节，包括康得新复合材料集团股份有限公司、江苏国泰国际集团国贸股份有限公司、江苏张家港农村商业银行股份有限公司、长江润发医药股份有限公司在内的10家张家港上市企业，与上海亚商发展集团有限公司、汉德资本、<a href="http://www.saifpartners.com.cn" target="_blank">赛富亚洲投资基金</a>等亚布力论坛理事企业成功牵手，跨出了“港城合伙人”打造区域性影响力和专业性的资本创新发展交流平台的第一步。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '此外，《张家港市上市公司与资本市场白皮书》在峰会上进行了发布。最后亚商集团董事长陈琦伟进行了总结致辞。',
        imgurl: '',
        imgDetail: ''
      }
    ]
  },
  {
    id: 26,
    title: '上海交通大学海外教育学院企业家创新俱乐部年会',
    Publisher: '亚商集团编辑',
    time: '2018.03.26',
    content: [
      {
        text: '会议主题“未来已来”——亚商集团董事长、亚商资本创始合伙人陈琦伟主讲《技术发展与产业升级的分享》',
        imgurl: 'news1-1.jpg',
        imgDetail: ''
      },
      {
        text: '亚商集团董事长、亚商资本创始合伙人陈琦伟为我们带来了题为《技术发展与产业升级的分享》，陈琦伟说道，近年来，随着生产成本的上升，Made in China的优势逐渐消退，加上污染聚集、资源过度消耗，中国制造在国际上陷入了低价竞争，产业需要从要素驱动，升级到技术驱动，变成Innovation in China，用技术的进步带动生产效率的提升，让产业结构全面升级。这方面的创新不但能得到资金支持，更能得到政策支持。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '基于这些前提，技术创新本身从引进技术到自我创新的实现就显得非常重要了，这个过程中经济环境的配套、知识产权、人才和资源的支持都必不可少。这次中美贸易战中，美国出自对本土高科技先进产业的保护，对中国技术类制造产业大力征税，这在一定程度上会影响到中国在美的技术优势。但我们也有自身的优势，比如互联网的快速发展，促成了一系列以BAT为首的诸如移动支付、娱乐、社交领域走到了世界前列。另外数据化、智能化也在广泛影响着中国的传统制造业，虽然说很多中小企业依然将面临短暂的“寒冬”，但只要我们敢于拥抱智能、数据，必定能拥有一个光明的未来。新时代对成功的定义也将改变，越来越倾向于那些专业能力强的，能够洞悉时代发展趋势而做比较精准的准备的人。',
        imgurl: '',
        imgDetail: ''
      }
    ]
  },
  {
    id: 27,
    title: '越研究越发现中国问题首先要靠实干',
    Publisher: '亚商集团编辑',
    time: '2018.02.27',
    content: [
      {
        text: '亚布力中国企业家论坛第十八届年会”于2018年2月27日-3月1日在黑龙江亚布力举行，主题为“改革开放四十周年 新时代的企业家精神”，亚商集团董事长，亚商资本创始合伙人陈琦伟出席并发言。',
        imgurl: 'news2.jpg',
        imgDetail: ''
      },
      {
        text: '陈琦伟有幸参与了改革的过程，当时他借调到国家体改委，跟吴敬琏参加了一系列世界银行的会议。他原来想研究经济学，后来越来越体悟到邓小平同志的伟大。“他也没想到他有那么伟大，他就觉得要务实。”',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '他回忆道：“当时我们在学校里还想着要务虚，研究经济学，后来越研究越发现中国的问题首先要靠干。”所以他对于务实越来越感兴趣，对企业家越来越感兴趣，因此经商的时候虽然是被动经商，但是一经商以后，对市场的感受就水到渠成了。',
        imgurl: '',
        imgDetail: ''
      }
    ]
  },
  {
    id: 28,
    title: '自主加工要有一个游戏规则',
    Publisher: '亚商集团编辑',
    time: '2013.02.23',
    content: [
      {
        text:'第十三届亚布力中国企业家论坛于2013年2月22日—24日在黑龙江亚布力召开。23日，创想发源地：永不消停的对峙——资本家VS企业家分论坛举行，众多企业家和学者参与了讨论。',
        imgurl: 'news3.jpg',
        imgDetail: ''
      },
      {
        text: '亚商集团的董事长陈琦伟在会上分享了创业过程中的教训：自主加工要有一个游戏规则。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '陈琦伟称中国的企业在公司治理的问题上缺乏理念，资本家这头多承担一点责任，要主动的跟创业家要沟通这个公司治理构架的重要性，不光是沟通，而且要实质性的帮他逐步建立起来。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '陈琦伟还觉得游戏规则很重要一点，投资比例从来不投超过20%，坚守20%以下。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '以下为文字实录：',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '陈琦伟：给大家抛砖引玉。我想主要结合故事讲，我会讲两个故事，同时我是会借着故事讲一个主题，这个主题是什么呢？就是资本家跟创业家之间的关系，这个游戏规则是什么，从我们自己体会来看，我们亚商到现在为止，我们自己是创业企业，我们投了大概80来家，但是我们第一家投的企业就是失败了，那是11年前，投了一家高科技的企业，做纳米材料，得了国家的科技进步奖，然后当时的三个国家领导人都跟他合影，江、李、朱，合影都挂在办公室里面，他本人是中科院院士，技术成分没有任何的疑问，订单全部都来了，这家公司当时我们一看非常的冲动，非常有激情，就当是投了他，因为他是院士科学家创业，自己在扩大，因为订单都来了，技术得到肯定了，扩大生产，扩大供应的能力不够，他需要钱，他自己没有钱，所以我们投了他第一笔钱，因为他没有钱，需要钱又有一定的数量，我们投进去钱以后，当时就占了他60%的股份，创业者是40%，结果运作了，运作以后马上问题就出来了，出来是两个原因，一个原因，是院士科研是很优秀的，但是一碰到财务问题跟普通人就一样了，他一看到这么多钱进来了，而且他是主管的，他说了算，马上决定一定要让他老婆来管财，我们也迁就他，11年前很多游戏规则也不懂，就尊重他了，第二，在运作中间，他就突然意识到我花的每一块钱都是100%是我的权利去花掉了，但是如果产生出利润以后有60%是这一家投资机构的，他法律的权利是40%，可以花钱的权利是100%，因此这样的话他对费用的开支就非常在乎，非常乐意。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '还有更重要一个问题，就是他掌握这么多权以后，我讲的这个故事，给我们最大的教训，就是这种早期企业进去以后，哪怕这么早期的企业应该跟他谈一个游戏规则，跟他谈建立好的公司治理构架。当时没有，他一用权，一花钱舒服了以后，跟他一起创业，我们还没有来得及去反映，跟他一起创业的团队，那两位就不干了，说这个成果得奖什么都是我们三个人一起做的一个小组，但是那个院士一看财权来了全部揽在了自己的手里，最后把实验室的东西到规模化生产，这个质量不能稳定，这样一下子最后企业就上不去了，就做了没有成功。这是一个案例。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '第二个案例，我们是在15年以后，大概在2004年的时候，投了一家企业，那家企业是做精细化工医药中间体的，成长非常快，当时我们也是因为这个董事长创办人跟我们关系很熟，跟我个人关系很熟，所以当时他也很豪爽，他说你这样吧，我们一起，你是第一家投资人进来，你占40%，然后就做起来了，但是可以做券商进来以后，其他投资机构也想进来，大家都跟他讲一个道理，说你看看这家公司要是上市成功的话，亚商他掌握40%的股份他们可以翻多少倍，然后你看也就是60%吧，他就在过程中间，不不是这个董事长本人，然后他下面那个团队就产生想法了，他们在外面自己就做老鼠仓了，自己培育同样的产品，供应，就在外面做了。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '那么这两个案例，我想这么讲，给我们一个大的教训，就是自主加工要有一个游戏规则，有几点，第一，哪怕是再早期的企业，VC的阶段，我们的体会就要跟他谈故事治理构架这个理念了，因为很多创业家他在一开始不会想到公司治理的问题，但是你这个理念就要跟他聊起来，特别是中国企业家在这上面比较欠缺，我们商业文化没有按照规矩办事，没有这个理念的，他希望你进来的时候，觉得这个资源他需要，需要资金，资金进来以后，觉得做起来以后，我们可以一起分享，但是这个游戏规则到底怎么定，他们是缺乏这个理念，我觉得资本家这头多承担一点责任，要主动的跟创业家要沟通这个公司治理构架的重要性，不光是沟通，而且要实质性的帮他逐步建立起来。',
        imgurl: '',
        imgDetail: ''
      },
      {
        text: '第二，我觉得游戏规则是很重要的一点，从此以后，我们从来不投超过20%，后来碰到很多一些好的案例，有的时候一开始人家谈的开心了，说你多投点，我们就跟他讲道理，我一多投，我把你的估值估高了，也不对，我坚守20%以下，我们投了三千万，收20%，等于是他的价值是一亿八左右，两亿左右了，但是其实企业不值那么多钱，但是我为了不超过20%，钱还是需要这样一些钱，这样我们就跟企业谈，比如说其他融资手段，分期到位，跟成果挂钩，总而言之，我们讲清楚，我们说一定不超过20%，原因是什么呢？我们认为成长型的企业，这个成长的利益主要应该让创业团队来享受，有人说他创业企业家一开始不是太懂，他觉得给到钱，给比例也可以，但是以后会产生想法的，这是人性的问题，不要说人家的想法不对，但是我们这个道理一讲以后，在安排股权结构这方面都比较会有帮助。',
        imgurl: '',
        imgDetail: ''
      }
    ]
  }
];



//////////////////
// WEBPACK FOOTER
// ./static/data/news-list.js
// module id = 8jli
// module chunks = 0